// User action types
export const REQUEST_USERS = 'REQUEST_USERS';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';
export const CREATE_USER = 'CREATE_USER';
export const SELECT_USER = 'SELECT_USER';

// Post action types
export const REQUEST_POSTS = 'REQUEST_POSTS';
export const FETCH_POSTS_SUCCESS = 'FETCH_POSTS_SUCCESS';
export const FETCH_POSTS_FAILURE = 'FETCH_POSTS_FAILURE';
export const REQUEST_COMMENTS = 'REQUEST_COMMENTS';
export const FETCH_COMMENTS_SUCCESS = 'FETCH_COMMENTS_SUCCESS';
export const FETCH_COMMENTS_FAILURE = 'FETCH_COMMENTS_FAILURE';
export const SELECT_POST = 'SELECT_POST';

// Product action types
export const DELETE_CATEGORY2_PRODUCT = 'DELETE_CATEGORY2_PRODUCT';
export const DELETE_CATEGORY2_PRODUCT_SUCCESS = 'DELETE_CATEGORY2_PRODUCT_SUCCESS';
export const DELETE_CATEGORY2_PRODUCT_FAILURE = 'DELETE_CATEGORY2_PRODUCT_FAILURE';
export const REQUEST_PRODUCTS = 'REQUEST_PRODUCTS';
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_FAILURE = 'FETCH_PRODUCTS_FAILURE';
export const FETCH_CATEGORY2_PRODUCTS_SUCCESS = 'FETCH_CATEGORY2_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_BY_CATEGORY2_FAILURE = 'FETCH_PRODUCTS_BY_CATEGORY2_FAILURE';
export const REQUEST_CATEGORY2_PRODUCTS = 'REQUEST_CATEGORY2_PRODUCTS';
export const REQUEST_PRODUCT_BY_NUM = 'REQUEST_PRODUCT_BY_NUM';
export const FETCH_PRODUCT_BY_NUM_SUCCESS = 'FETCH_PRODUCT_BY_NUM_SUCCESS';
export const FETCH_PRODUCT_BY_NUM_FAILURE = 'FETCH_PRODUCT_BY_NUM_FAILURE';
export const REQUEST_NEXT_PRODUCT = 'REQUEST_NEXT_PRODUCT';
export const FETCH_NEXT_PRODUCT_SUCCESS = 'FETCH_NEXT_PRODUCT_SUCCESS';
export const FETCH_NEXT_PRODUCT_FAILURE = 'FETCH_NEXT_PRODUCT_FAILURE';
export const REQUEST_PREVIOUS_PRODUCT = 'REQUEST_PREVIOUS_PRODUCT';
export const FETCH_PREVIOUS_PRODUCT_SUCCESS = 'FETCH_PREVIOUS_PRODUCT_SUCCESS';
export const FETCH_PREVIOUS_PRODUCT_FAILURE = 'FETCH_PREVIOUS_PRODUCT_FAILURE';
export const REQUEST_PRODUCTS_BY_VENDOR = 'REQUEST_PRODUCTS_BY_VENDOR';
export const FETCH_PRODUCTS_BY_VENDOR_SUCCESS = 'FETCH_PRODUCTS_BY_VENDOR_SUCCESS';
export const FETCH_PRODUCTS_BY_VENDOR_FAILURE = 'FETCH_PRODUCTS_BY_VENDOR_FAILURE';
export const FETCH_VENDOR_BATCHES = 'FETCH_VENDOR_BATCHES';
export const FETCH_VENDOR_BATCHES_SUCCESS = 'FETCH_VENDOR_BATCHES_SUCCESS';
export const FETCH_VENDOR_BATCHES_FAILURE = 'FETCH_VENDOR_BATCHES_FAILURE';
export const FETCH_RELATED_PRODUCTS = 'FETCH_RELATED_PRODUCTS';
export const FETCH_RELATED_PRODUCTS_SUCCESS = 'FETCH_RELATED_PRODUCTS_SUCCESS';
export const FETCH_RELATED_PRODUCTS_FAILURE = 'FETCH_RELATED_PRODUCTS_FAILURE';
export const SELECT_PRODUCT = 'SELECT_PRODUCT';
export const RESET_CURRENT_PRODUCT = 'RESET_CURRENT_PRODUCT';
export const CLEAR_CURRENT_PRODUCT = 'CLEAR_CURRENT_PRODUCT';
export const SET_GROUP_CATEGORY = 'SET_GROUP_CATEGORY';
export const REQUEST_CREATING_PRODUCT = 'REQUEST_CREATING_PRODUCT';
export const CREATE_PRODUCT_SUCCESS = 'CREATE_PRODUCT_SUCCESS';
export const CREATE_PRODUCT_FAILURE = 'CREATE_PRODUCT_FAILURE';
export const REQUEST_EDITING_PRODUCT = 'REQUEST_EDITING_PRODUCT';
export const EDIT_PRODUCT_SUCCESS = 'EDIT_PRODUCT_SUCCESS';
export const EDIT_PRODUCT_FAILURE = 'EDIT_PRODUCT_FAILURE';
export const REQUEST_EDITING_MULTI_PRODUCT = 'REQUEST_EDITING_MULTI_PRODUCT';
export const EDIT_MULTI_PRODUCT_SUCCESS = 'EDIT_MULTI_PRODUCT_SUCCESS';
export const EDIT_MULTI_PRODUCT_FAILURE = 'EDIT_MULTI_PRODUCT_FAILURE';
export const REQUEST_PRODUCT_DETAIL = 'REQUEST_PRODUCT_DETAIL';
export const FETCH_PRODUCT_DETAIL_SUCCESS = 'FETCH_PRODUCT_DETAIL_SUCCESS';
export const FETCH_PRODUCT_DETAIL_FAILURE = 'FETCH_PRODUCT_DETAIL_FAILURE';
export const REQUEST_DISPLAY_CATEGORIES = 'REQUEST_DISPLAY_CATEGORIES';
export const FETCH_DISPLAY_CATEGORIES_SUCCESS = 'FETCH_DISPLAY_CATEGORIES_SUCCESS';
export const FETCH_DISPLAY_CATEGORIES_FAILURE = 'FETCH_DISPLAY_CATEGORIES_FAILURE';
export const REQUEST_EDIT_DISPLAY_CATEGORIES = 'REQUEST_EDIT_DISPLAY_CATEGORIES';
export const EDIT_DISPLAY_CATEGORIES_SUCCESS = 'EDIT_DISPLAY_CATEGORIES_SUCCESS';
export const EDIT_DISPLAY_CATEGORIES_FAILURE = 'EDIT_DISPLAY_CATEGORIES_FAILURE';
export const REQUEST_PRODUCT_INFO = 'REQUEST_PRODUCT_INFO';
export const FETCH_PRODUCT_INFO_SUCCESS = 'FETCH_PRODUCT_INFO_SUCCESS';
export const FETCH_PRODUCT_INFO_FAILURE = 'FETCH_PRODUCT_INFO_FAILURE';
export const ATTACH_PRODUCT_IMAGE = 'ATTACH_PRODUCT_IMAGE';
export const ATTACH_PRODUCT_IMAGE_SUCCESS = 'ATTACH_PRODUCT_IMAGE_SUCCESS';
export const ATTACH_PRODUCT_IMAGE_FAILURE = 'ATTACH_PRODUCT_IMAGE_FAILURE';
export const CLEAR_ATTACHED_PRODUCT_IMAGE = 'CLEAR_ATTACHED_PRODUCT_IMAGE';
export const FETCH_SUGGESTED_PROD_NUM = 'FETCH_SUGGESTED_PROD_NUM';
export const FETCH_SUGGESTED_PROD_NUM_SUCCESS = 'FETCH_SUGGESTED_PROD_NUM_SUCCESS';
export const FETCH_SUGGESTED_PROD_NUM_FAILURE = 'FETCH_SUGGESTED_PROD_NUM_FAILURE';
export const FETCH_SUGGEST_DIGIT = 'FETCH_SUGGEST_DIGIT';
export const FETCH_SUGGEST_DIGIT_SUCCESS = 'FETCH_SUGGEST_DIGIT_SUCCESS';
export const FETCH_SUGGEST_DIGIT_FAILURE = 'FETCH_SUGGEST_DIGIT_FAILURE';
export const CLEAR_SUGGEST_DIGIT = 'CLEAR_SUGGEST_DIGIT';
export const FETCH_PACKAGE_TYPES = 'FETCH_PACKAGE_TYPES';
export const FETCH_PACKAGE_TYPES_SUCCESS = 'FETCH_PACKAGE_TYPES_SUCCESS';
export const FETCH_PACKAGE_TYPES_FAILURE = 'FETCH_PACKAGE_TYPES_FAILURE';
export const EDIT_PACKAGE_TYPE = 'EDIT_PACKAGE_TYPE';
export const EDIT_PACKAGE_TYPE_SUCCESS = 'EDIT_PACKAGE_TYPE_SUCCESS';
export const EDIT_PACKAGE_TYPE_FAILURE = 'EDIT_PACKAGE_TYPE_FAILURE';
export const CLEAR_PACKAGE_TYPE_EDITED = 'CLEAR_PACKAGE_TYPE_EDITED';
export const REQUEST_DELETE_PACKAGE_TYPE = 'REQUEST_DELETE_PACKAGE_TYPE';
export const DELETE_PACKAGE_TYPE_SUCCESS = 'DELETE_PACKAGE_TYPE_SUCCESS';
export const DELETE_PACKAGE_TYPE_FAILURE = 'DELETE_PACKAGE_TYPE_FAILURE';
export const FETCH_MEASUREMENT_UNIT = 'FETCH_MEASUREMENT_UNIT';
export const FETCH_MEASUREMENT_UNIT_SUCCESS = 'FETCH_MEASUREMENT_UNIT_SUCCESS';
export const FETCH_MEASUREMENT_UNIT_FAILURE = 'FETCH_MEASUREMENT_UNIT_FAILURE';
export const EDIT_MEASUREMENT_UNIT = 'EDIT_MEASUREMENT_UNIT';
export const EDIT_MEASUREMENT_UNIT_SUCCESS = 'EDIT_MEASUREMENT_UNIT_SUCCESS';
export const EDIT_MEASUREMENT_UNIT_FAILURE = 'EDIT_MEASUREMENT_UNIT_FAILURE';
export const CLEAR_MEASUREMENT_UNIT_EDITED = 'CLEAR_MEASUREMENT_UNIT_EDITED';
export const REQUEST_DELETE_MEASUREMENT_UNIT = 'REQUEST_DELETE_MEASUREMENT_UNIT';
export const DELETE_MEASUREMENT_UNIT_SUCCESS = 'DELETE_MEASUREMENT_UNIT_SUCCESS';
export const DELETE_MEASUREMENT_UNIT_FAILURE = 'DELETE_MEASUREMENT_UNIT_FAILURE';
export const FETCH_CONVERTABLE_PRODUCTS = 'FETCH_CONVERTABLE_PRODUCTS';
export const FETCH_CONVERTABLE_PRODUCTS_SUCCESS = 'FETCH_CONVERTABLE_PRODUCTS_SUCCESS';
export const FETCH_CONVERTABLE_PRODUCTS_FAILURE = 'FETCH_CONVERTABLE_PRODUCTS_FAILURE';
export const FETCH_PRODUCT_PARTS_LIST = 'FETCH_PRODUCT_PARTS_LIST';
export const FETCH_PRODUCT_PARTS_LIST_SUCCESS = 'FETCH_PRODUCT_PARTS_LIST_SUCCESS';
export const FETCH_PRODUCT_PARTS_LIST_FAILURE = 'FETCH_PRODUCT_PARTS_LIST_FAILURE';
export const SET_CURRENT_PRODUCT = 'SET_CURRENT_PRODUCT';
export const REQUEST_GROUPS = 'REQUEST_GROUPS';
export const FETCH_GROUPS_SUCCESS = 'FETCH_GROUPS_SUCCESS';
export const FETCH_GROUPS_FAILURE = 'FETCH_GROUPS_FAILURE';
export const SELECT_GROUP = 'SELECT_GROUP';
export const SELECT_DEP = 'SELECT_DEP';
export const RESET_CURRENT_GROUP = 'RESET_CURRENT_GROUP';
export const REQUEST_CREATING_GROUP = 'REQUEST_CREATING_GROUP';
export const CREATE_GROUP_SUCCESS = 'CREATE_GROUP_SUCCESS';
export const CREATE_GROUP_FAILURE = 'CREATE_GROUP_FAILURE';
export const REQUEST_EDITING_GROUP = 'REQUEST_EDITING_GROUP';
export const EDIT_GROUP_SUCCESS = 'EDIT_GROUP_SUCCESS';
export const EDIT_GROUP_FAILURE = 'EDIT_GROUP_FAILURE';
export const REQUEST_EDITING_MULTI_GROUPS = 'REQUEST_EDITING_MULTI_GROUPS';
export const EDIT_MULTI_GROUPS_SUCCESS = 'EDIT_MULTI_GROUPS_SUCCESS';
export const EDIT_MULTI_GROUPS_FAILURE = 'EDIT_MULTI_GROUPS_FAILURE';
export const REQUEST_GROUP_DETAIL = 'REQUEST_GROUP_DETAIL';
export const FETCH_GROUP_DETAIL_SUCCESS = 'FETCH_GROUP_DETAIL_SUCCESS';
export const FETCH_GROUP_DETAIL_FAILURE = 'FETCH_GROUP_DETAIL_FAILURE';
export const REQUEST_CATEGORIES = 'REQUEST_CATEGORIES';
export const FETCH_CATEGORIES_SUCCESS = 'FETCH_CATEGORIES_SUCCESS';
export const FETCH_CATEGORIES_FAILURE = 'FETCH_CATEGORIES_FAILURE';
export const REQUEST_GROUP_CATEGORIES = 'REQUEST_GROUP_CATEGORIES';
export const REQUEST_DEP_CATEGORIES = 'REQUEST_DEP_CATEGORIES';
export const REQUEST_DEP_CATEGORIES_ALT = 'REQUEST_DEP_CATEGORIES_ALT';

export const REQUEST_GROUP_CATEGORIES_ALT = 'REQUEST_GROUP_CATEGORIES_ALT';
export const FETCH_GROUP_CATEGORIES_SUCCESS_ALT = 'FETCH_GROUP_CATEGORIES_SUCCESS_ALT';

export const FETCH_GROUP_CATEGORIES_SUCCESS = 'FETCH_GROUP_CATEGORIES_SUCCESS';
export const FETCH_DEP_CATEGORIES_SUCCESS = 'FETCH_DEP_CATEGORIES_SUCCESS';
export const FETCH_DEP_CATEGORIES_SUCCESS_ALT = 'FETCH_DEP_CATEGORIES_SUCCESS_ALT';
export const FETCH_GROUP_CATEGORIES_FAILURE = 'FETCH_GROUP_CATEGORIES_FAILURE';
export const SELECT_CATEGORY = 'SELECT_CATEGORY';
export const RESET_CURRENT_CATEGORY = 'RESET_CURRENT_CATEGORY';
export const REQUEST_CREATING_CATEGORY = 'REQUEST_CREATING_CATEGORY';
export const CREATE_CATEGORY_SUCCESS = 'CREATE_CATEGORY_SUCCESS';
export const CREATE_CATEGORY_FAILURE = 'CREATE_CATEGORY_FAILURE';
export const EDIT_MULTI_TAXES = 'EDIT_MULTI_TAXES';
export const EDIT_MULTI_TAXES_SUCCESS = 'EDIT_MULTI_TAXES_SUCCESS';
export const EDIT_MULTI_TAXES_FAILURE = 'EDIT_MULTI_TAXES_FAILURE';
export const DELETE_TAX = 'DELETE_TAX';
export const DELETE_TAX_SUCCESS = 'DELETE_TAX_SUCCESS';
export const DELETE_TAX_FAILURE = 'DELETE_TAX_FAILURE';
export const REQUEST_EDITING_CATEGORY = 'REQUEST_EDITING_CATEGORY';
export const EDIT_CATEGORY_SUCCESS = 'EDIT_CATEGORY_SUCCESS';
export const EDIT_CATEGORY_FAILURE = 'EDIT_CATEGORY_FAILURE';
export const REQUEST_EDITING_MULTI_CATEGORIES = 'REQUEST_EDITING_MULTI_CATEGORIES';
export const EDIT_MULTI_CATEGORIES_SUCCESS = 'EDIT_MULTI_CATEGORIES_SUCCESS';
export const EDIT_MULTI_CATEGORIES_FAILURE = 'EDIT_MULTI_CATEGORIES_FAILURE';
export const REQUEST_CATEGORIES_2 = 'REQUEST_CATEGORIES_2';
export const FETCH_CATEGORIES_2_SUCCESS = 'FETCH_CATEGORIES_2_SUCCESS';
export const FETCH_CATEGORIES_2_FAILURE = 'FETCH_CATEGORIES_2_FAILURE';
export const REQUEST_EDITING_MULTI_CATEGORIES_2 = 'REQUEST_EDITING_MULTI_CATEGORIES_2';
export const EDIT_MULTI_CATEGORIES_2_SUCCESS = 'EDIT_MULTI_CATEGORIES_2_SUCCESS';
export const EDIT_MULTI_CATEGORIES_2_FAILURE = 'EDIT_MULTI_CATEGORIES_2_FAILURE';
export const REQUEST_DELETE_CATEGORY_2 = 'REQUEST_DELETE_CATEGORY_2';
export const DELETE_CATEGORY_2_SUCCESS = 'DELETE_CATEGORY_2_SUCCESS';
export const DELETE_CATEGORY_2_FAILURE = 'DELETE_CATEGORY_2_FAILURE';
export const CLEAR_CATEGORY_2_STATUS = 'CLEAR_CATEGORY_2_STATUS';
//B2B start
export const REQUEST_CATEGORIES_2_B2B = 'REQUEST_CATEGORIES_2_B2B';
export const FETCH_CATEGORIES_2_SUCCESS_B2B = 'FETCH_CATEGORIES_2_SUCCESS_B2B';
export const FETCH_CATEGORIES_2_FAILURE_B2B = 'FETCH_CATEGORIES_2_FAILURE_B2B';
export const REQUEST_EDITING_MULTI_CATEGORIES_2_B2B = 'REQUEST_EDITING_MULTI_CATEGORIES_2_B2B';
export const EDIT_MULTI_CATEGORIES_2_SUCCESS_B2B = 'EDIT_MULTI_CATEGORIES_2_SUCCESS_B2B';
export const EDIT_MULTI_CATEGORIES_2_FAILURE_B2B = 'EDIT_MULTI_CATEGORIES_2_FAILURE_B2B';
export const REQUEST_DELETE_CATEGORY_2_B2B = 'REQUEST_DELETE_CATEGORY_2_B2B';
export const DELETE_CATEGORY_2_SUCCESS_B2B = 'DELETE_CATEGORY_2_SUCCESS_B2B';
export const DELETE_CATEGORY_2_FAILURE_B2B = 'DELETE_CATEGORY_2_FAILURE_B2B';
export const CLEAR_CATEGORY_2_STATUS_B2B = 'CLEAR_CATEGORY_2_STATUS_B2B';
export const SELECT_CATEGORY_B2B = "SELECT_CATEGORY_B2B";
export const RESET_CURRENT_CATEGORY_B2B = "RESET_CURRENT_CATEGORY_B2B";
export const REQUEST_CATEGORY2_PRODUCTS_B2B = "REQUEST_CATEGORY2_PRODUCTS_B2B";
export const FETCH_CATEGORY2_PRODUCTS_SUCCESS_B2B = "FETCH_CATEGORY2_PRODUCTS_SUCCESS_B2B";
export const FETCH_CATEGORY2_PRODUCTS_FAILURE_B2B = "FETCH_CATEGORY2_PRODUCTS_FAILURE_B2B";
//B2B end
export const REQUEST_ACTION_LOG = 'REQUEST_ACTION_LOG';
export const FETCH_ACTION_LOG_SUCCESS = 'FETCH_ACTION_LOG_SUCCESS';
export const FETCH_ACTION_LOG_FAILURE = 'FETCH_ACTION_LOG_FAILURE';
export const REQUEST_CONTINUE_OR_DISCONTINUE_PRODUCT = 'REQUEST_CONTINUE_PRODUCT';
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAILURE = "DELETE_PRODUCT_FAILURE";
export const CONTINUE_OR_DISCONTINUE_PRODUCT_SUCCESS = 'CONTINUE_PRODUCT_SUCCESS';
export const CONTINUE_OR_DISCONTINUE_PRODUCT_FAILURE = 'CONTINUE_PRODUCT_FAILURE';
export const SAVE_MOBILE_DESCRIPTION_BOX_TEXT_SUCCESS = 'SAVE_MOBILE_DESCRIPTION_BOX_TEXT_SUCCESS';
export const SAVE_MOBILE_DESCRIPTION_BOX_TEXT_FAILURE = 'SAVE_MOBILE_DESCRIPTION_BOX_TEXT_FAILURE';
export const REQUEST_SAVE_MOBILE_DESCRIPTION_BOX_TEXT = 'REQUEST_SAVE_MOBILE_DESCRIPTION_BOX_TEXT';
export const RESET_CATEGORY2_ID = 'RESET_CATEGORY2_ID';

export const RESET_GROUP_AND_CATEGORY = 'RESET_GROUP_AND_CATEGORY';
export const RESET_CATEGORY = 'RESET_CATEGORY';
export const REQUEST_TYPES = 'REQUEST_TYPES';
export const FETCH_TYPES_SUCCESS = 'FETCH_TYPES_SUCCESS';
export const FETCH_TYPES_FAILURE = 'FETCH_TYPES_FAILURE';
export const REQUEST_PRICELEVELS = 'REQUEST_PRICELEVELS';
export const FETCH_PRICELEVELS_SUCCESS = 'FETCH_PRICELEVELS_SUCCESS';
export const FETCH_PRICELEVELS_FAILURE = 'FETCH_PRICELEVELS_FAILURE';
export const REQUEST_EDITING_MULTI_PRICELEVELS = 'REQUEST_EDITING_MULTI_PRICELEVELS';
export const EDIT_MULTI_PRICELEVELS_SUCCESS = 'EDIT_MULTI_PRICELEVELS_SUCCESS';
export const EDIT_MULTI_PRICELEVELS_FAILURE = 'EDIT_MULTI_PRICELEVELS_FAILURE';
export const REQUEST_SIMPLIFIED_PRODUCTS = 'REQUEST_SIMPLIFIED_PRODUCTS';
export const FETCH_SIMPLIFIED_PRODUCTS_SUCCESS = 'FETCH_SIMPLIFIED_PRODUCTS_SUCCESS';
export const FETCH_SIMPLIFIED_PRODUCTS_FAILURE = 'FETCH_SIMPLIFIED_PRODUCTS_FAILURE';
export const REQUEST_DELETE_CATEGORY = 'REQUEST_DELETE_CATEGORY';
export const DELETE_CATEGORY_SUCCESS = 'DELETE_CATEGORY_SUCCESS';
export const DELETE_CATEGORY_FAILURE = 'DELETE_CATEGORY_FAILURE';
export const REQUEST_DELETE_GROUP = 'REQUEST_DELETE_GROUP';
export const DELETE_GROUP_SUCCESS = 'DELETE_GROUP_SUCCESS';
export const DELETE_PRODUCT_DEP_SUCCESS = 'DELETE_PRODUCT_DEP_SUCCESS';
export const REQUEST_DELETE_DEP = 'REQUEST_DELETE_DEP';
export const REQUEST_DEPS = 'REQUEST_DEPS';
export const REQUEST_PURCHASER = 'REQUEST_PURCHASER';
export const FETCH_PURCHASER_SUCCESS = 'FETCH_PURCHASER_SUCCESS';
export const FETCH_PURCHASER_FAILURE = 'FETCH_PURCHASER_FAILURE';
export const FETCH_DEPS_SUCCESS = 'FETCH_DEPS_SUCCESS';
export const REQUEST_EDITING_MULTI_DEPS = 'REQUEST_EDITING_MULTI_DEPS';
export const EDIT_MULTI_DEPS_SUCCESS = 'EDIT_MULTI_DEPS_SUCCESS';
export const DELETE_PRODUCT_GROUP_SUCCESS = 'DELETE_PRODUCT_GROUP_SUCCESS';
export const DELETE_GROUP_FAILURE = 'DELETE_GROUP_FAILURE';
export const CLEAR_CATEGORY_STATUS = 'CLEAR_CATEGORY_STATUS';
export const CLEAR_GROUP_STATUS = 'CLEAR_GROUP_STATUS';
export const REINITIALZIE_PRODUCT_FORM = 'REINITIALZIE_PRODUCT_FORM';
export const REQUEST_SMALL_PRODUCT_INFO = 'REQUEST_SMALL_PRODUCT_INFO';
export const FETCH_SMALL_PRODUCT_INFO_SUCCESS = 'FETCH_SMALL_PRODUCT_INFO_SUCCESS';
export const FETCH_SMALL_PRODUCT_INFO_FAILURE = 'FETCH_SMALL_PRODUCT_INFO_FAILURE';
export const CLEAR_SMALL_PRODUCT = 'CLEAR_SMALL_PRODUCT';
export const REQUEST_CRV_VALUES = 'REQUEST_CRV_VALUES';
export const FETCH_CRV_VALUES_SUCCESS = 'FETCH_CRV_VALUES_SUCCESS';
export const FETCH_CRV_VALUES_FAILURE = 'FETCH_CRV_VALUES_FAILURE';

export const REQUEST_DEFAULT_BUYERS = 'REQUEST_DEFAULT_BUYERS';
export const REQUEST_DEFAULT_BUYERS_SUCCESS = 'REQUEST_DEFAULT_BUYERS_SUCCESS';
export const REQUEST_DEFAULT_BUYERS_FAILURE = 'REQUEST_DEFAULT_BUYERS_FAILURE';

export const REQUEST_UPDATE_PRODUCT = 'REQUEST_UPDATE_PRODUCT';
export const UPDATE_PRODUCT_SUCCEESS = 'UPDATE_PRODUCT_SUCCEESS';
export const UPDATE_PRODUCT_FAILURE = 'UPDATE_PRODUCT_FAILURE';

// Customer action types
export const REQUEST_CUSTOMERS = 'REQUEST_CUSTOMERS';
export const FETCH_CUSTOMERS_SUCCESS = 'FETCH_CUSTOMERS_SUCCESS';
export const FETCH_CUSTOMERS_FAILURE = 'FETCH_CUSTOMERS_FAILURE';
export const REQUEST_CUSTOMERS_OPTIONS = 'REQUEST_CUSTOMERS_OPTIONS';
export const FETCH_CUSTOMERS_OPTIONS_SUCCESS = 'FETCH_CUSTOMERS_OPTIONS_SUCCESS';
export const FETCH_CUSTOMERS_OPTIONS_FAILURE = 'FETCH_CUSTOMERS_OPTIONS_FAILURE';
export const REQUEST_CUSTOMERS_PAGINATE = 'REQUEST_CUSTOMERS_PAGINATE';
export const FETCH_CUSTOMERS_PAGINATE_SUCCESS = 'FETCH_CUSTOMERS_PAGINATE_SUCCESS';
export const FETCH_CUSTOMERS_PAGINATE_FAILURE = 'FETCH_CUSTOMERS_PAGINATE_FAILURE';
export const SELECT_CUSTOMER = 'SELECT_CUSTOMER';
export const RESET_CURRENT_CUSTOMER = 'RESET_CURRENT_CUSTOMER';
export const REQUEST_CREATING_CUSTOMER = 'REQUEST_CREATING_CUSTOMER';
export const CREATE_CUSTOMER_SUCCESS = 'CREATE_CUSTOMER_SUCCESS';
export const CREATE_CUSTOMER_FAILURE = 'CREATE_CUSTOMER_FAILURE';
export const REQUEST_EDITING_CUSTOMER = 'REQUEST_EDITING_CUSTOMER';
export const EDIT_CUSTOMER_SUCCESS = 'EDIT_CUSTOMER_SUCCESS';
export const EDIT_CUSTOMER_FAILURE = 'EDIT_CUSTOMER_FAILURE';
export const REQUEST_CUSTOMER_DETAIL = 'REQUEST_CUSTOMER_DETAIL';
export const FETCH_CUSTOMER_DETAIL_SUCCESS = 'FETCH_CUSTOMER_DETAIL_SUCCESS';
export const FETCH_CUSTOMER_DETAIL_FAILURE = 'FETCH_CUSTOMER_DETAIL_FAILURE';
export const REQUEST_CUSTOMER_CREDIT_BY_DATE = 'REQUEST_CUSTOMER_CREDIT_BY_DATE';
export const FETCH_CUSTOMER_CREDIT_BY_DATE_SUCCESS = 'FETCH_CUSTOMER_CREDIT_BY_DATE_SUCCESS';
export const FETCH_CUSTOMER_CREDIT_BY_DATE_FAILURE = 'FETCH_CUSTOMER_CREDIT_BY_DATE_FAILURE';
export const REQUEST_CUSTOMERS_STATUS = 'REQUEST_CUSTOMERS_STATUS';
export const FETCH_CUSTOMERS_STATUS_SUCCESS = 'FETCH_CUSTOMERS_STATUS_SUCCESS';
export const FETCH_CUSTOMERS_STATUS_FAILURE = 'FETCH_CUSTOMERS_STATUS_FAILURE';

// Payment term action types
export const REQUEST_PAYMENTTERMS = 'REQUEST_PAYMENTTERMS';
export const FETCH_PAYMENTTERMS_SUCCESS = 'FETCH_PAYMENTTERMS_SUCCESS';
export const FETCH_PAYMENTTERMS_FAILURE = 'FETCH_PAYMENTTERMS_FAILURE';
export const SELECT_PAYMENTTERM = 'SELECT_PAYMENTTERM';
export const RESET_CURRENT_PAYMENTTERM = 'RESET_CURRENT_PAYMENTTERM';
export const RESET_CREATE_PAYMENT_TERM = 'RESET_CREATE_PAYMENT_TERM';
export const RESET_EDIT_PAYMENT_TERM = 'RESET_EDIT_PAYMENT_TERM';
export const REQUEST_CREATING_PAYMENT_TERM = 'REQUEST_CREATING_PAYMENT_TERM';
export const CREATE_PAYMENT_TERM_SUCCESS = 'CREATE_PAYMENT_TERM_SUCCESS';
export const CREATE_PAYMENT_TERM_FAILURE = 'CREATE_PAYMENT_TERM_FAILURE';
export const REQUEST_EDITING_PAYMENT_TERM = 'REQUEST_EDITING_PAYMENT_TERM';
export const EDIT_PAYMENT_TERM_SUCCESS = 'EDIT_PAYMENT_TERM_SUCCESS';
export const EDIT_PAYMENT_TERM_FAILURE = 'EDIT_PAYMENT_TERM_FAILURE';
export const REQUEST_GENERAL_REPORT = 'REQUEST_GENERAL_REPORT';
export const FETCH_GENERAL_REPORT_SUCCESS = 'FETCH_GENERAL_REPORT_SUCCESS';
export const FETCH_GENERAL_REPORT_FAILURE = 'FETCH_GENERAL_REPORT_FAILURE';
export const REQUEST_CITY_REPORT = 'REQUEST_CITY_REPORT';
export const FETCH_CITY_REPORT_SUCCESS = 'FETCH_CITY_REPORT_SUCCESS';
export const FETCH_CITY_REPORT_FAILURE = 'FETCH_CITY_REPORT_FAILURE';
export const RESET_CITY_REPORT = 'RESET_CITY_REPORT';
export const REQUEST_CUSTOMER_STATEMENT = 'REQUEST_CUSTOMER_STATEMENT';
export const FETCH_CUSTOMER_STATEMENT_SUCCESS = 'FETCH_CUSTOMER_STATEMENT_SUCCESS';
export const FETCH_CUSTOMER_STATEMENT_FAILURE = 'FETCH_CUSTOMER_STATEMENT_FAILURE';
export const REQUEST_CUSTOMER_STATEMENT_LIST = 'REQUEST_CUSTOMER_STATEMENT_LIST';
export const FETCH_CUSTOMER_STATEMENT_LIST_SUCCESS = 'FETCH_CUSTOMER_STATEMENT_LIST_SUCCESS';
export const FETCH_CUSTOMER_STATEMENT_LIST_FAILURE = 'FETCH_CUSTOMER_STATEMENT_LIST_FAILURE';
export const REQUEST_VENDOR_STATEMENT_LIST = 'REQUEST_VENDOR_STATEMENT_LIST';
export const FETCH_VENDOR_STATEMENT_LIST_SUCCESS = 'FETCH_VENDOR_STATEMENT_LIST_SUCCESS';
export const FETCH_VENDOR_STATEMENT_LIST_FAILURE = 'FETCH_VENDOR_STATEMENT_LIST_FAILURE';
export const REQUEST_MOBILE_CUSTOMER_STATEMENT = 'REQUEST_MOBILE_CUSTOMER_STATEMENT';
export const FETCH_MOBILE_CUSTOMER_STATEMENT_SUCCESS = 'FETCH_MOBILE_CUSTOMER_STATEMENT_SUCCESS';
export const FETCH_MOBILE_CUSTOMER_STATEMENT_FAILURE = 'FETCH_MOBILE_CUSTOMER_STATEMENT_FAILURE';
export const RESET_MOBILE_CUSTOMER_STATEMENT = 'RESET_MOBILE_CUSTOMER_STATEMENT';

// Vendor action types
export const REQUEST_VENDORS = 'REQUEST_VENDORS';
export const FETCH_VENDORS_SUCCESS = 'FETCH_VENDORS_SUCCESS';
export const FETCH_VENDORS_FAILURE = 'FETCH_VENDORS_FAILURE';
export const SELECT_VENDOR = 'SELECT_VENDOR';
export const RESET_CURRENT_VENDOR = 'RESET_CURRENT_VENDOR';
export const REQUEST_CREATING_VENDOR = 'REQUEST_CREATING_VENDOR'
export const CREATE_VENDOR_SUCCESS = 'CREATE_VENDOR_SUCCESS'
export const CREATE_VENDOR_FAILURE = 'CREATE_VENDOR_FAILURE'
export const REQUEST_EDITING_VENDOR = 'REQUEST_EDITING_VENDOR';
export const EDIT_VENDOR_SUCCESS = 'EDIT_VENDOR_SUCCESS';
export const EDIT_VENDOR_FAILURE = 'EDIT_VENDOR_FAILURE';
export const REQUEST_VENDOR_DETAIL = 'REQUEST_VENDOR_DETAIL';
export const REQUEST_VENDOR_STATEMENT = 'REQUEST_VENDOR_STATEMENT';
export const FETCH_VENDOR_STATEMENT_SUCCESS = 'FETCH_VENDOR_STATEMENT_SUCCESS';
export const FETCH_VENDOR_STATEMENT_FAILURE = 'FETCH_VENDOR_STATEMENT_FAILURE';
export const FETCH_VENDOR_DETAIL_SUCCESS = 'FETCH_VENDOR_DETAIL_SUCCESS';
export const FETCH_VENDOR_DETAIL_FAILURE = 'FETCH_VENDOR_DETAIL_FAILURE';
export const REQUEST_VENDOR_INVENTORY_DETAIL = 'REQUEST_VENDOR_INVENTORY_DETAIL';
export const FETCH_VENDOR_INVENTORY_DETAIL_SUCCESS = 'FETCH_VENDOR_INVENTORY_DETAIL_SUCCESS';
export const FETCH_VENDOR_INVENTORY_DETAIL_FAILURE = 'FETCH_VENDOR_INVENTORY_DETAIL_FAILURE';
export const REQUEST_VENDOR_RECORDS = 'REQUEST_VENDOR_RECORDS';
export const FETCH_VENDOR_RECORDS_SUCCESS = 'FETCH_VENDOR_RECORDS_SUCCESS';
export const FETCH_VENDOR_RECORDS_FAILURE = 'FETCH_VENDOR_RECORDS_FAILURE';

// Agent action types
export const REQUEST_AGENTS = 'REQUEST_AGENTS';
export const FETCH_AGENTS_SUCCESS = 'FETCH_AGENTS_SUCCESS';
export const FETCH_AGENTS_FAILURE = 'FETCH_AGENTS_FAILURE';
export const SELECT_AGENT = 'SELECT_AGENT';
export const RESET_CURRENT_AGENT = 'RESET_CURRENT_AGENT';
export const REQUEST_CREATING_AGENT = 'REQUEST_CREATING_AGENT';
export const CREATE_AGENT_SUCCESS = 'CREATE_AGENT_SUCCESS';
export const CREATE_AGENT_FAILURE = 'CREATE_AGENT_FAILURE';
export const REQUEST_EDITING_AGENT = 'REQUEST_EDITING_AGENT';
export const EDIT_AGENT_SUCCESS = 'EDIT_AGENT_SUCCESS';
export const EDIT_AGENT_FAILURE = 'EDIT_AGENT_FAILURE';
export const REQUEST_AGENT_DETAIL = 'REQUEST_AGENT_DETAIL';
export const FETCH_AGENT_DETAIL_SUCCESS = 'FETCH_AGENT_DETAIL_SUCCESS';
export const FETCH_AGENT_DETAIL_FAILURE = 'FETCH_AGENT_DETAIL_FAILURE';

// Auth action types
export const REQUEST_AUTH = 'REQUEST_AUTH';
export const AUTH_USERID = 'AUTH_USERID';
export const AUTH_USER = 'AUTH_USER';
export const AUTH_USER_PERMISSIONS = 'AUTH_USER_PERMISSIONS';
export const UNAUTH_USER = 'UNAUTH_USER';
export const AUTH_ERROR = 'AUTH_ERROR';
export const FETCH_MESSAGE = 'FETCH_MESSAGE';

// Purchase Quote action types
export const REQUEST_PURCHASE_QUOTES = 'REQUEST_PURCHASE_QUOTES';
export const FETCH_PURCHASE_QUOTES_SUCCESS = 'FETCH_PURCHASE_QUOTES_SUCCESS';
export const FETCH_PURCHASE_QUOTES_FAILURE = 'FETCH_PURCHASE_QUOTES_FAILURE';
export const SELECT_PURCHASE_QUOTE = 'SELECT_PURCHASE_QUOTE';
export const RESET_CURRENT_PURCHASE_QUOTE = 'RESET_CURRENT_PURCHASE_QUOTE';
export const REQUEST_PURCHASE_QUOTE_DETAIL = 'REQUEST_PURCHASE_QUOTE_DETAIL';
export const FETCH_PURCHASE_QUOTE_DETAIL_SUCCESS = 'FETCH_PURCHASE_QUOTE_DETAIL_SUCCESS';
export const FETCH_PURCHASE_QUOTE_DETAIL_FAILURE = 'FETCH_PURCHASE_QUOTE_DETAIL_FAILURE';
export const REQUEST_CREATING_PURCHASE_QUOTE = 'REQUEST_CREATING_PURCHASE_QUOTE';
export const CREATE_PURCHASE_QUOTE_SUCCESS = 'CREATE_PURCHASE_QUOTE_SUCCESS';
export const CREATE_PURCHASE_QUOTE_FAILURE = 'CREATE_PURCHASE_QUOTE_FAILURE';
export const REQUEST_PURCHASE_QUOTE_PLACE = 'REQUEST_PURCHASE_QUOTE_PLACE';
export const PURCHASE_QUOTE_PLACE_SUCCESS = 'PURCHASE_QUOTE_PLACE_SUCCESS';
export const PURCHASE_QUOTE_PLACE_FAILURE = 'PURCHASE_QUOTE_PLACE_FAILURE';
export const REQUEST_EDITING_PURCHASE_QUOTE = 'REQUEST_EDITING_PURCHASE_QUOTE';
export const EDIT_PURCHASE_QUOTE_SUCCESS = 'EDIT_PURCHASE_QUOTE_SUCCESS';
export const EDIT_PURCHASE_QUOTE_FAILURE = 'EDIT_PURCHASE_QUOTE_FAILURE';
export const REQUEST_NUM_PURCHASE_QUOTES = 'REQUEST_NUM_PURCHASE_QUOTES';
export const FETCH_NUM_PURCHASE_QUOTES_SUCCESS = 'FETCH_NUM_PURCHASE_QUOTES_SUCCESS';
export const FETCH_NUM_PURCHASE_QUOTES_FAILURE = 'FETCH_NUM_PURCHASE_QUOTES_FAILURE';
export const REQUEST_TODAYS_INCOMING_ORDERS = 'REQUEST_TODAYS_INCOMING_ORDERS';
export const FETCH_TODAYS_INCOMING_ORDERS_SUCCESS = 'FETCH_TODAYS_INCOMING_ORDERS_SUCCESS';
export const FETCH_TODAYS_INCOMING_ORDERS_FAILURE = 'FETCH_TODAYS_INCOMING_ORDERS_FAILURE';
export const REQUEST_DELETE_PURCHASE_QUOTE = 'REQUEST_DELETE_PURCHASE_QUOTE';
export const DELETE_PURCHASE_QUOTE_SUCCESS = 'DELETE_PURCHASE_QUOTE_SUCCESS';
export const DELETE_PURCHASE_QUOTE_FAILURE = 'DELETE_PURCHASE_QUOTE_FAILURE';

// Purchase Template action types
export const REQUEST_PURCHASE_TEMPLATES = 'REQUEST_PURCHASE_TEMPLATES';
export const FETCH_PURCHASE_TEMPLATES_SUCCESS = 'FETCH_PURCHASE_TEMPLATES_SUCCESS';
export const FETCH_PURCHASE_TEMPLATES_FAILURE = 'FETCH_PURCHASE_TEMPLATES_FAILURE';
export const SELECT_PURCHASE_TEMPLATE = 'SELECT_PURCHASE_TEMPLATE';
export const RESET_CURRENT_PURCHASE_TEMPLATE = 'RESET_CURRENT_PURCHASE_TEMPLATE';
export const REQUEST_PURCHASE_TEMPLATE_DETAIL = 'REQUEST_PURCHASE_TEMPLATE_DETAIL';
export const FETCH_PURCHASE_TEMPLATE_DETAIL_SUCCESS = 'FETCH_PURCHASE_TEMPLATE_DETAIL_SUCCESS';
export const FETCH_PURCHASE_TEMPLATE_DETAIL_FAILURE = 'FETCH_PURCHASE_TEMPLATE_DETAIL_FAILURE';
export const REQUEST_CREATING_PURCHASE_TEMPLATE = 'REQUEST_CREATING_PURCHASE_TEMPLATE';
export const CREATE_PURCHASE_TEMPLATE_SUCCESS = 'CREATE_PURCHASE_TEMPLATE_SUCCESS';
export const CREATE_PURCHASE_TEMPLATE_FAILURE = 'CREATE_PURCHASE_TEMPLATE_FAILURE';
export const REQUEST_EDITING_PURCHASE_TEMPLATE = 'REQUEST_EDITING_PURCHASE_TEMPLATE';
export const EDIT_PURCHASE_TEMPLATE_SUCCESS = 'EDIT_PURCHASE_TEMPLATE_SUCCESS';
export const EDIT_PURCHASE_TEMPLATE_FAILURE = 'EDIT_PURCHASE_TEMPLATE_FAILURE';
export const RESET_CURRENT_PURCHASE_PRODUCT = 'RESET_CURRENT_PURCHASE_PRODUCT';
export const DELETE_PURCHASE_TEMPLATE = 'DELETE_PURCHASE_TEMPLATE';
export const DELETE_PURCHASE_TEMPLATE_SUCCESS = 'DELETE_PURCHASE_TEMPLATE_SUCCESS';
export const DELETE_PURCHASE_TEMPLATE_FAILURE = 'DELETE_PURCHASE_TEMPLATE_FAILURE';
export const REQUEST_PURCHASE_TEMPLATE_LIST = 'REQUEST_PURCHASE_TEMPLATE_LIST';
export const FETCH_PURCHASE_TEMPLATE_LIST_SUCCESS = 'FETCH_PURCHASE_TEMPLATE_LIST_SUCCESS';
export const FETCH_PURCHASE_TEMPLATE_LIST_FAILURE = 'FETCH_PURCHASE_TEMPLATE_LIST_FAILURE';

// Purchase Schedule action types
export const REQUEST_PURCHASE_SCHEDULES = 'REQUEST_PURCHASE_SCHEDULES';
export const FETCH_PURCHASE_SCHEDULES_SUCCESS = 'FETCH_PURCHASE_SCHEDULES_SUCCESS';
export const FETCH_PURCHASE_SCHEDULES_FAILURE = 'FETCH_PURCHASE_SCHEDULES_FAILURE';
export const SELECT_PURCHASE_SCHEDULE = 'SELECT_PURCHASE_SCHEDULE';
export const RESET_CURRENT_PURCHASE_SCHEDULE = 'RESET_CURRENT_PURCHASE_SCHEDULE';
export const REQUEST_PURCHASE_SCHEDULE_DETAIL = 'REQUEST_PURCHASE_SCHEDULE_DETAIL';
export const FETCH_PURCHASE_SCHEDULE_DETAIL_SUCCESS = 'FETCH_PURCHASE_SCHEDULE_DETAIL_SUCCESS';
export const FETCH_PURCHASE_SCHEDULE_DETAIL_FAILURE = 'FETCH_PURCHASE_SCHEDULE_DETAIL_FAILURE';
export const REQUEST_CREATING_PURCHASE_SCHEDULE = 'REQUEST_CREATING_PURCHASE_SCHEDULE';
export const CREATE_PURCHASE_SCHEDULE_SUCCESS = 'CREATE_PURCHASE_SCHEDULE_SUCCESS';
export const CREATE_PURCHASE_SCHEDULE_FAILURE = 'CREATE_PURCHASE_SCHEDULE_FAILURE';
export const REQUEST_EDITING_PURCHASE_SCHEDULE = 'REQUEST_EDITING_PURCHASE_SCHEDULE';
export const EDIT_PURCHASE_SCHEDULE_SUCCESS = 'EDIT_PURCHASE_SCHEDULE_SUCCESS';
export const EDIT_PURCHASE_SCHEDULE_FAILURE = 'EDIT_PURCHASE_SCHEDULE_FAILURE';

// Purchase Return action types
export const REQUEST_PURCHASE_RETURNS = 'REQUEST_PURCHASE_RETURNS';
export const FETCH_PURCHASE_RETURNS_SUCCESS = 'FETCH_PURCHASE_RETURNS_SUCCESS';
export const FETCH_PURCHASE_RETURNS_FAILURE = 'FETCH_PURCHASE_RETURNS_FAILURE';
export const SELECT_PURCHASE_RETURN = 'SELECT_PURCHASE_RETURN';
// export const SELECT_PURCHASE_RETURN_VENDOR = 'SELECT_PURCHASE_RETURN_VENDOR';
export const RESET_CURRENT_PURCHASE_RETURN = 'RESET_CURRENT_PURCHASE_RETURN';
export const REQUEST_PURCHASE_RETURN_DETAIL = 'REQUEST_PURCHASE_RETURN_DETAIL';
export const FETCH_PURCHASE_RETURN_DETAIL_SUCCESS = 'FETCH_PURCHASE_RETURN_DETAIL_SUCCESS';
export const FETCH_PURCHASE_RETURN_DETAIL_FAILURE = 'FETCH_PURCHASE_RETURN_DETAIL_FAILURE';
export const REQUEST_CREATING_PURCHASE_RETURN = 'REQUEST_CREATING_PURCHASE_RETURN';
export const CREATE_PURCHASE_RETURN_SUCCESS = 'CREATE_PURCHASE_RETURN_SUCCESS';
export const CREATE_PURCHASE_RETURN_FAILURE = 'CREATE_PURCHASE_RETURN_FAILURE';
export const REQUEST_EDITING_PURCHASE_RETURN = 'REQUEST_EDITING_PURCHASE_RETURN';
export const EDIT_PURCHASE_RETURN_SUCCESS = 'EDIT_PURCHASE_RETURN_SUCCESS';
export const EDIT_PURCHASE_RETURN_FAILURE = 'EDIT_PURCHASE_RETURN_FAILURE';
export const COMPLETE_PURCHASE_RETURN = 'COMPLETE_PURCHASE_RETURN';
export const COMPLETE_PURCHASE_RETURN_SUCCESS = 'COMPLETE_PURCHASE_RETURN_SUCCESS';
export const COMPLETE_PURCHASE_RETURN_FAILURE = 'COMPLETE_PURCHASE_RETURN_FAILURE';
export const REQUEST_PURCHASE_RETURN_PDF = 'REQUEST_PURCHASE_RETURN_PDF';
export const FETCH_PURCHASE_RETURN_PDF_SUCCESS = 'FETCH_PURCHASE_RETURN_PDF_SUCCESS';
export const REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL = 'REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL'
export const REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL_SUCCESS = 'REQUEST_PURCHASE_RETURN_PDF_NO_SUBTOTAL_SUCCESS'
export const REQUEST_VOID_PURCHASE_RETURN = 'REQUEST_VOID_PURCHASE_RETURN';
export const VOID_PURCHASE_RETURN_SUCCESS = 'VOID_PURCHASE_RETURN_SUCCESS';
export const VOID_PURCHASE_RETURN_FAILURE = 'VOID_PURCHASE_RETURN_FAILURE';

// Purchase Order action types
export const REQUEST_PURCHASE_ORDERS = 'REQUEST_PURCHASE_ORDERS';
export const FETCH_PURCHASE_ORDERS_SUCCESS = 'FETCH_PURCHASE_ORDERS_SUCCESS';
export const FETCH_PURCHASE_ORDERS_FAILURE = 'FETCH_PURCHASE_ORDERS_FAILURE';
export const REQUEST_PURCHASE_ORDERS_BY_FILTER = 'REQUEST_PURCHASE_ORDERS_BY_FILTER';
export const SELECT_PURCHASE_ORDER = 'SELECT_PURCHASE_ORDER';
export const RESET_CURRENT_PURCHASE_ORDER = 'RESET_CURRENT_PURCHASE_ORDER';
export const REQUEST_PURCHASE_ORDER_DETAIL = 'REQUEST_PURCHASE_ORDER_DETAIL';
export const FETCH_PURCHASE_ORDER_DETAIL_SUCCESS = 'FETCH_PURCHASE_ORDER_DETAIL_SUCCESS';
export const FETCH_PURCHASE_ORDER_DETAIL_FAILURE = 'FETCH_PURCHASE_ORDER_DETAIL_FAILURE';
export const REQUEST_CREATING_PURCHASE_ORDER = 'REQUEST_CREATING_PURCHASE_ORDER';
export const CREATE_PURCHASE_ORDER_SUCCESS = 'CREATE_PURCHASE_ORDER_SUCCESS';
export const CREATE_PURCHASE_ORDER_FAILURE = 'CREATE_PURCHASE_ORDER_FAILURE';
export const REQUEST_EDITING_PURCHASE_ORDER = 'REQUEST_EDITING_PURCHASE_ORDER';
export const EDIT_PURCHASE_ORDER_SUCCESS = 'EDIT_PURCHASE_ORDER_SUCCESS';
export const EDIT_PURCHASE_ORDER_FAILURE = 'EDIT_PURCHASE_ORDER_FAILURE';
export const REQUEST_PURCHASE_ORDERS_NOT_RECEIVED = 'REQUEST_PURCHASE_ORDERS_NOT_RECEIVED';
export const FETCH_PURCHASE_ORDERS_NOT_RECEIVED_SUCCESS = 'FETCH_PURCHASE_ORDERS_NOT_RECEIVED_SUCCESS';
export const FETCH_PURCHASE_ORDERS_NOT_RECEIVED_FAILURE = 'FETCH_PURCHASE_ORDERS_NOT_RECEIVED_FAILURE';
export const REQUEST_TOTAL_PURCHASES = 'REQUEST_TOTAL_PURCHASES';
export const FETCH_TOTAL_PURCHASES_SUCCESS = 'FETCH_TOTAL_PURCHASES_SUCCESS';
export const FETCH_TOTAL_PURCHASES_FAILURE = 'FETCH_TOTAL_PURCHASES_FAILURE';
export const REQUEST_PRINT_PURCHASE_ORDER = 'REQUEST_PRINT_PURCHASE_ORDER';
export const PRINT_PURCHASE_ORDER_SUCCESS = 'PRINT_PURCHASE_ORDER_SUCCESS';
export const PRINT_PURCHASE_ORDER_FAILURE = 'PRINT_PURCHASE_ORDER_FAILURE';
export const REQUEST_DELETE_PURCHASE_ORDER = 'REQUEST_DELETE_PURCHASE_ORDER';
export const DELETE_PURCHASE_ORDER_SUCCESS = 'DELETE_PURCHASE_ORDER_SUCCESS';
export const DELETE_PURCHASE_ORDER_FAILURE = 'DELETE_PURCHASE_ORDER_FAILURE';
export const REQUEST_PURCHASE_ORDER_PERFORMANCE = 'REQUEST_PURCHASE_ORDER_PERFORMANCE';
export const FETCH_PURCHASE_ORDER_PERFORMANCE_SUCCESS = 'FETCH_PURCHASE_ORDER_PERFORMANCE_SUCCESS';
export const FETCH_PURCHASE_ORDER_PERFORMANCE_FAILURE = 'FETCH_PURCHASE_ORDER_PERFORMANCE_FAILURE';
export const REQUEST_PURCHASE_MANAGER_INFO = 'REQUEST_PURCHASE_MANAGER_INFO';
export const FETCH_PURCHASE_MANAGER_INFO_SUCCESS = 'FETCH_PURCHASE_MANAGER_INFO_SUCCESS';
export const FETCH_PURCHASE_MANAGER_INFO_FAILURE = 'FETCH_PURCHASE_MANAGER_INFO_FAILURE';
export const REQUEST_LAST_MONTH_PERFORMANCE = 'REQUEST_LAST_MONTH_PERFORMANCE';
export const FETCH_LAST_MONTH_PERFORMANCE_SUCCESS = 'FETCH_LAST_MONTH_PERFORMANCE_SUCCESS';
export const FETCH_LAST_MONTH_PERFORMANCE_FAILURE = 'FETCH_LAST_MONTH_PERFORMANCE_FAILURE';
export const REQUEST_PURCHASERS_PERFORMANCE = 'REQUEST_PURCHASERS_PERFORMANCE';
export const FETCH_PURCHASERS_PERFORMANCE_SUCCESS = 'FETCH_PURCHASERS_PERFORMANCE_SUCCESS';
export const FETCH_PURCHASERS_PERFORMANCE_FAILURE = 'FETCH_PURCHASERS_PERFORMANCE_FAILURE';
export const REQUEST_PRESIDENT_DASH_INFO = 'REQUEST_PRESIDENT_DASH_INFO';
export const FETCH_PRESIDENT_DASH_INFO_SUCCESS = 'FETCH_PRESIDENT_DASH_INFO_SUCCESS';
export const FETCH_PRESIDENT_DASH_INFO_FAILURE = 'FETCH_PRESIDENT_DASH_INFO_FAILURE';
export const REQUEST_OVERALL_PURCHASE_PERFORMANCE = 'REQUEST_OVERALL_PURCHASE_PERFORMANCE';
export const FETCH_OVERALL_PURCHASE_PERFORMANCE_SUCCESS = 'FETCH_OVERALL_PURCHASE_PERFORMANCE_SUCCESS';
export const FETCH_OVERALL_PURCHASE_PERFORMANCE_FAILURE = 'FETCH_OVERALL_PURCHASE_PERFORMANCE_FAILURE';
export const REQUEST_INCIDENT_REPORT = 'REQUEST_INCIDENT_REPORT';
export const FETCH_INCIDENT_REPORT_SUCCESS = 'FETCH_INCIDENT_REPORT_SUCCESS';
export const FETCH_INCIDENT_REPORT_FAILURE = 'FETCH_INCIDENT_REPORT_FAILURE';
export const REQUEST_PURCHASE_ORDER_LIST = 'REQUEST_PURCHASE_ORDER_LIST';
export const FETCH_PURCHASE_ORDER_LIST_SUCCESS = 'FETCH_PURCHASE_ORDER_LIST_SUCCESS';
export const FETCH_PURCHASE_ORDER_LIST_FAILURE = 'FETCH_PURCHASE_ORDER_LIST_FAILURE';
export const SET_PURCHASE_ORDERS_FILTER = 'SET_PURCHASE_ORDERS_FILTER';
export const REQUEST_PURCHASING_PERFORMANCE = 'REQUEST_PURCHASING_PERFORMANCE';
export const REQUEST_PURCHASING_PERFORMANCE_BY_FILTER = 'REQUEST_PURCHASING_PERFORMANCE_BY_FILTER';
export const FETCH_PURCHASING_PERFORMANCE_SUCCESS = 'FETCH_PURCHASING_PERFORMANCE_SUCCESS';
export const FETCH_PURCHASING_PERFORMANCE_FAILURE = 'FETCH_PURCHASING_PERFORMANCE_FAILURE';
export const REQUEST_PURCHASING_PERFORMANCE_BY_FILTER_GFD = 'REQUEST_PURCHASING_PERFORMANCE_BY_FILTER_GFD';
export const FETCH_PURCHASING_PERFORMANCE_SUCCESS_GFD = 'FETCH_PURCHASING_PERFORMANCE_SUCCESS_GFD';
export const REQUEST_PRICE_ADJUSTMENT = 'REQUEST_PRICE_ADJUSTMENT';
export const FETCH_PRICE_ADJUSTMENT_SUCCESS = 'FETCH_PRICE_ADJUSTMENT_SUCCESS';
export const FETCH_PRICE_ADJUSTMENT_FAILURE = 'FETCH_PRICE_ADJUSTMENT_FAILURE';
export const CREATE_PRICE_ADJUSTMENT = 'CREATE_PRICE_ADJUSTMENT';
export const CREATE_PRICE_ADJUSTMENT_SUCCESS = 'CREATE_PRICE_ADJUSTMENT_SUCCESS';
export const CREATE_PRICE_ADJUSTMENT_FAILURE = 'CREATE_PRICE_ADJUSTMENT_FAILURE';
export const REQUEST_PURCHASE_PIVOT_CHART_ORDERS = 'REQUEST_PURCHASE_PIVOT_CHART_ORDERS';
export const FETCH_PURCHASE_PIVOT_CHART_ORDERS_SUCCESS = 'FETCH_PURCHASE_PIVOT_CHART_ORDERS_SUCCESS';
export const FETCH_PURCHASE_PIVOT_CHART_ORDERS_FAILURE = 'FETCH_PURCHASE_PIVOT_CHART_ORDERS_FAILURE';
export const REQUEST_PURCHASE_PIVOT_CHARTS = 'REQUEST_PURCHASE_PIVOT_CHARTS';
export const FETCH_PURCHASE_PIVOT_CHARTS_SUCCESS = 'FETCH_PURCHASE_PIVOT_CHARTS_SUCCESS';
export const FETCH_PURCHASE_PIVOT_CHARTS_FAILURE = 'FETCH_PURCHASE_PIVOT_CHARTS_FAILURE';
export const REQUEST_PURCHASE_PIVOT_CHARTS_DETAIL = 'REQUEST_PURCHASE_PIVOT_CHARTS_DETAIL';
export const FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_SUCCESS = 'FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_SUCCESS';
export const FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_FAILURE = 'FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_FAILURE';
export const SET_PURCHASE_PIVOT_ID = 'SET_PURCHASE_PIVOT_ID';
export const RESET_PURCHASE_PIVOT_CHARTS = 'RESET_PURCHASE_PIVOT_CHARTS';
export const CREATE_PURCHASE_PIVOT_CHART = 'CREATE_PURCHASE_PIVOT_CHART';
export const CREATE_PURCHASE_PIVOT_CHART_SUCCESS = 'CREATE_PURCHASE_PIVOT_CHART_SUCCESS';
export const CREATE_PURCHASE_PIVOT_CHART_FAILURE = 'CREATE_PURCHASE_PIVOT_CHART_FAILURE';
export const DUPLICATE_PURCHASE_PIVOT_CHART = 'DUPLICATE_PURCHASE_PIVOT_CHART';
export const DUPLICATE_PURCHASE_PIVOT_CHART_SUCCESS = 'DUPLICATE_PURCHASE_PIVOT_CHART_SUCCESS';
export const DUPLICATE_PURCHASE_PIVOT_CHART_FAILURE = 'DUPLICATE_PURCHASE_PIVOT_CHART_FAILURE';
export const CLEAR_DUPLICATED_PURCHASE_PIVOT_CHART = 'CLEAR_DUPLICATED_PURCHASE_PIVOT_CHART';
export const REQUEST_PURCHASE_REFERENCE_PDF = 'REQUEST_PURCHASE_REFERENCE_PDF';
export const FETCH_PURCHASE_REFERENCE_PDF_SUCCESS = 'FETCH_PURCHASE_REFERENCE_PDF_SUCCESS';
export const REQUEST_PURCHASING_REFERENCE = 'REQUEST_PURCHASING_REFERENCE';
export const FETCH_PURCHASING_REFERENCE_SUCCESS = 'FETCH_PURCHASING_REFERENCE_SUCCESS';
export const FETCH_PURCHASING_REFERENCE_FAILURE = 'FETCH_PURCHASING_REFERENCE_FAILURE';
export const REQUEST_PURCHASE_PAYMENT_NOT_PAID = 'REQUEST_PURCHASE_PAYMENT_NOT_PAID';
export const FETCH_PURCHASE_PAYMENT_NOT_PAID_SUCCESS = 'FETCH_PURCHASE_PAYMENT_NOT_PAID_SUCCESS';
export const FETCH_PURCHASE_PAYMENT_NOT_PAID_FAILURE = 'FETCH_PURCHASE_PAYMENT_NOT_PAID_FAILURE';
export const REQUEST_PURCHASING_PERFORMANCE_BY_PRODUCT = 'REQUEST_PURCHASING_PERFORMANCE_BY_PRODUCT';
export const FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_SUCCESS = 'FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_SUCCESS';
export const FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_FAILURE = 'FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_FAILURE';
export const REQUEST_PURCHASE_PRODUCT_BY_ID = 'REQUEST_PURCHASE_PRODUCT_BY_ID';
export const FETCH_PURCHASE_PRODUCT_BY_ID_SUCCESS = 'FETCH_PURCHASE_PRODUCT_BY_ID_SUCCESS';
export const FETCH_PURCHASE_PRODUCT_BY_ID_FAILURE = 'FETCH_PURCHASE_PRODUCT_BY_ID_FAILURE';
export const FETCH_INVENTORIES_DETAILS_SUCCESS = 'FETCH_INVENTORIES_DETAILS_SUCCESS';
export const RESET_FILTER_WITH_NEW_ID = 'RESET_FILTER_WITH_NEW_ID';
export const FETCH_INVENTORIES_PRODUCT_RECEIVE_SUCCESS = 'FETCH_INVENTORIES_PRODUCT_RECEIVE_SUCCESS';
export const RESET_RECEIVE_FILTER_WITH_NEW_ID = "RESET_RECEIVE_FILTER_WITH_NEW_ID";
export const FETCH_SHIPPING_ADVICE_DETAIL_SUCCESS = "FETCH_SHIPPING_ADVICE_DETAIL_SUCCESS";
// Inventory action types
export const REQUEST_INVENTORIES = 'REQUEST_INVENTORIES';
export const FETCH_INVENTORIES_SUCCESS = 'FETCH_INVENTORIES_SUCCESS';
export const FETCH_INVENTORIES_FAILURE = 'FETCH_INVENTORIES_FAILURE';
export const REQUEST_DETAILED_INVENTORIES = 'REQUEST_DETAILED_INVENTORIES';
export const FETCH_DETAILED_INVENTORIES_SUCCESS = 'FETCH_DETAILED_INVENTORIES_SUCCESS';
export const FETCH_DETAILED_INVENTORIES_FAILURE = 'FETCH_DETAILED_INVENTORIES_FAILURE';
export const REQUEST_LOW_STOCK_INVENTORIES = 'REQUEST_LOW_STOCK_INVENTORIES';
export const FETCH_LOW_STOCK_INVENTORIES_SUCCESS = 'FETCH_LOW_STOCK_INVENTORIES_SUCCESS';
export const FETCH_LOW_STOCK_INVENTORIES_FAILURE = 'FETCH_LOW_STOCK_INVENTORIES_FAILURE';
export const REQUEST_EXPIRED_INVENTORIES = 'REQUEST_EXPIRED_INVENTORIES';
export const FETCH_EXPIRED_INVENTORIES_SUCCESS = 'FETCH_EXPIRED_INVENTORIES_SUCCESS';
export const FETCH_EXPIRED_INVENTORIES_FAILURE = 'FETCH_EXPIRED_INVENTORIES_FAILURE';
export const REQUEST_INVENTORIES_BY_GROUP = 'REQUEST_INVENTORIES_BY_GROUP';
export const REQUEST_INVENTORIES_BY_GROUP_SUCCESS = 'REQUEST_INVENTORIES_BY_GROUP_SUCCESS';
export const REQUEST_INVENTORIES_BY_GROUP_FAILURE = 'REQUEST_INVENTORIES_BY_GROUP_FAILURE';
export const REQUEST_INVENTORIES_BY_CATEGORY = 'REQUEST_INVENTORIES_BY_CATEGORY';
export const REQUEST_INVENTORIES_BY_CATEGORY_SUCCESS = 'REQUEST_INVENTORIES_BY_CATEGORY_SUCCESS';
export const REQUEST_INVENTORIES_BY_CATEGORY_FAILURE = 'REQUEST_INVENTORIES_BY_CATEGORY_FAILURE';
export const REQUEST_INVENTORIES_BY_PERIOD = 'REQUEST_INVENTORIES_BY_PERIOD';
export const FETCH_INVENTORIES_BY_PERIOD_SUCCESS = 'FETCH_INVENTORIES_BY_PERIOD_SUCCESS';
export const FETCH_INVENTORIES_BY_PERIOD_FAILURE = 'FETCH_INVENTORIES_BY_PERIOD_FAILURE';
export const REQUEST_LOW_INVENTORIES = 'REQUEST_LOW_INVENTORIES';
export const FETCH_LOW_INVENTORIES_SUCCESS = 'FETCH_LOW_INVENTORIES_SUCCESS';
export const FETCH_LOW_INVENTORIES_FAILURE = 'FETCH_LOW_INVENTORIES_FAILURE';
export const REQUEST_WORKING_ORDERS = 'REQUEST_WORKING_ORDERS';
export const FETCH_WORKING_ORDERS_SUCCESS = 'FETCH_WORKING_ORDERS_SUCCESS';
export const FETCH_WORKING_ORDERS_FAILURE = 'FETCH_WORKING_ORDERS_FAILURE';
export const CHECK_PASSWORD = 'CHECK_PASSWORD';
export const CHECK_PASSWORD_SUCCESS = 'CHECK_PASSWORD_SUCCESS';
export const CHECK_PASSWORD_FAILURE = 'CHECK_PASSWORD_FAILURE';
export const CLEAR_CHECK_PASSWORD = 'CLEAR_CHECK_PASSWORD';
export const CHECK_PERMISSIOIN = 'CHECK_PERMISSIOIN';
export const CHECK_PERMISSIOIN_SUCCESS = 'CHECK_PERMISSIOIN_SUCCESS';
export const CHECK_PERMISSIOIN_FAILURE = 'CHECK_PERMISSIOIN_FAILURE';
export const SET_ORIGIN_PAGE = 'SET_ORIGIN_PAGE';
export const SELECT_INVENTORY = 'SELECT_INVENTORY';
export const RESET_CURRENT_INVENTORY = 'RESET_CURRENT_INVENTORY';
export const REQUEST_INVENTORY_DETAIL = 'REQUEST_INVENTORY_DETAIL';
export const FETCH_INVENTORY_DETAIL_SUCCESS = 'FETCH_INVENTORY_DETAIL_SUCCESS';
export const FETCH_INVENTORY_DETAIL_FAILURE = 'FETCH_INVENTORY_DETAIL_FAILURE';
export const FETCH_INVENTORY_SCRAP = 'FETCH_INVENTORY_SCRAP';
export const FETCH_INVENTORY_SCRAP_SUCCESS = 'FETCH_INVENTORY_SCRAP_SUCCESS';
export const FETCH_INVENTORY_SCRAP_FAILURE = 'FETCH_INVENTORY_SCRAP_FAILURE';
export const REQUEST_CREATING_SCRAP_RECORD = 'REQUEST_CREATING_SCRAP_RECORD';
export const CREATE_SCRAP_RECORD_SUCCESS = 'CREATE_SCRAP_RECORD_SUCCESS';
export const CREATE_SCRAP_RECORD_FAILURE = 'CREATE_SCRAP_RECORD_FAILURE';
export const REQUEST_EDITING_SCRAP_RECORD = 'REQUEST_EDITING_SCRAP_RECORD';
export const EDIT_SCRAP_RECORD_SUCCESS = 'EDIT_SCRAP_RECORD_SUCCESS';
export const EDIT_SCRAP_RECORD_FAILURE = 'EDIT_SCRAP_RECORD_FAILURE';
export const REQUEST_PUT_AWAY = 'REQUEST_PUT_AWAY';
export const FETCH_PUT_AWAY_SUCCESS = 'FETCH_PUT_AWAY_SUCCESS';
export const FETCH_PUT_AWAY_FAILURE = 'FETCH_PUT_AWAY_FAILURE';
export const RESET_CURRENT_PUT_AWAY = 'RESET_CURRENT_PUT_AWAY';
export const REQUEST_CREATING_PUT_AWAY = 'REQUEST_CREATING_PUT_AWAY';
export const CREATE_PUT_AWAY_SUCCESS = 'CREATE_PUT_AWAY_SUCCESS';
export const CREATE_PUT_AWAY_FAILURE = 'CREATE_PUT_AWAY_FAILURE';
export const SELECT_PUT_AWAY = 'SELECT_PUT_AWAY';
export const REQUEST_PUT_AWAY_DETAIL = 'REQUEST_PUT_AWAY_DETAIL';
export const FETCH_PUT_AWAY_DETAIL_SUCCESS = 'FETCH_PUT_AWAY_DETAIL_SUCCESS';
export const FETCH_PUT_AWAY_DETAIL_FAILURE = 'FETCH_PUT_AWAY_DETAIL_FAILURE';
export const REQUEST_EDITING_PUT_AWAY = 'REQUEST_EDITING_PUT_AWAY';
export const EDIT_PUT_AWAY_SUCCESS = 'EDIT_PUT_AWAY_SUCCESS';
export const EDIT_PUT_AWAY_FAILURE = 'EDIT_PUT_AWAY_FAILURE';
export const AUTO_PUTAWAY = 'AUTO_PUTAWAY';
export const AUTO_PUTAWAY_SUCCESS = 'AUTO_PUTAWAY_SUCCESS';
export const AUTO_PUTAWAY_FAILURE = 'AUTO_PUTAWAY_FAILURE';
export const REQUEST_BIN_LIST_DETAIL = 'REQUEST_BIN_LIST_DETAIL';
export const FETCH_BIN_LIST_DETAIL_SUCCESS = 'FETCH_BIN_LIST_DETAIL_SUCCESS';
export const FETCH_BIN_LIST_DETAIL_FAILURE = 'FETCH_BIN_LIST_DETAIL_FAILURE';
export const REQUEST_CREATING_BINS = 'REQUEST_CREATING_BINS';
export const CREATE_BINS_SUCCESS = 'CREATE_BINS_SUCCESS';
export const CREATE_BINS_FAILURE = 'CREATE_BINS_FAILURE';
export const SELECT_WAREHOUSE_RECEIVE = 'SELECT_WAREHOUSE_RECEIVE';
export const RESET_CURRENT_WAREHOUSE_RECEIVE = 'RESET_CURRENT_WAREHOUSE_RECEIVE';
export const REQUEST_NONZERO_INVENTORIES = 'REQUEST_NONZERO_INVENTORIES';
export const FETCH_NONZERO_INVENTORIES_SUCCESS = 'FETCH_NONZERO_INVENTORIES_SUCCESS';
export const FETCH_NONZERO_INVENTORIES_FAILURE = 'FETCH_NONZERO_INVENTORIES_FAILURE';
export const FETCH_INVENTORY_HISTORY = 'FETCH_INVENTORY_HISTORY';
export const FETCH_INVENTORY_HISTORY_SUCCESS = 'FETCH_INVENTORY_HISTORY_SUCCESS';
export const FETCH_INVENTORY_HISTORY_FAILURE = 'FETCH_INVENTORY_HISTORY_FAILURE';
export const FETCH_INVENTORY_ADJUSTMENT_BATCH_LOG = "FETCH_INVENTORY_ADJUSTMENT_BATCH_LOG";
export const UPDATE_INVENTORY_FILTER = 'UPDATE_INVENTORY_FILTER';
export const UPDATE_RECEIVE_TABLE_FILTER = 'UPDATE_RECEIVE_TABLE_FILTER';

// Favorites action types
export const REQUEST_FAVORITES = 'REQUEST_FAVORITES';
export const FETCH_FAVORITES_SUCCESS = 'FETCH_FAVORITES_SUCCESS';
export const FETCH_FAVORITES_FAILURE = 'FETCH_FAVORITES_FAILURE';
export const SELECT_FAVORITES = 'SELECT_FAVORITES';
export const RESET_CURRENT_FAVORITES = 'RESET_CURRENT_FAVORITES';
export const REQUEST_FAVORITES_DETAIL = 'REQUEST_FAVORITES_DETAIL';
export const FETCH_FAVORITES_DETAIL_SUCCESS = 'FETCH_FAVORITES_DETAIL_SUCCESS';
export const FETCH_FAVORITES_DETAIL_FAILURE = 'FETCH_FAVORITES_DETAIL_FAILURE';
export const REQUEST_ADDING_FAVORITE = 'REQUEST_ADDING_FAVORITE';
export const ADD_FAVORITE_SUCCESS = 'ADD_FAVORITE_SUCCESS';
export const ADD_FAVORITE_FAILURE = 'ADD_FAVORITE_FAILURE';
export const REQUEST_DELETE_FAVORITE = 'REQUEST_DELETE_FAVORITE';
export const DELETE_FAVORITE_SUCCESS = 'DELETE_FAVORITE_SUCCESS';
export const DELETE_FAVORITE_FAILURE = 'DELETE_FAVORITE_FAILURE';
export const ITEM_IN_LIST = 'ITEM_IN_LIST';
export const CLEAR_IN_LIST_ERROR = 'CLEAR_IN_LIST_ERROR';
export const REQUEST_FAVORITE_LIST = 'REQUEST_FAVORITE_LIST';
export const FETCH_FAVORITE_LIST_SUCCESS = 'FETCH_FAVORITE_LIST_SUCCESS';
export const FETCH_FAVORITE_LIST_FAILURE = 'FETCH_FAVORITE_LIST_FAILURE';
export const REQUEST_SAVE_FAVORITE_LIST = 'REQUEST_SAVE_FAVORITE_LIST';
export const SAVE_FAVORITE_LIST_SUCCESS = 'SAVE_FAVORITE_LIST_SUCCESS';
export const SAVE_FAVORITE_LIST_FAILURE = 'SAVE_FAVORITE_LIST_FAILURE';

// Promotions action types
export const REQUEST_PROMOTIONS = 'REQUEST_PROMOTIONS';
export const FETCH_PROMOTIONS_SUCCESS = 'FETCH_PROMOTIONS_SUCCESS';
export const FETCH_PROMOTIONS_FAILURE = 'FETCH_PROMOTIONS_FAILURE';
export const SELECT_PROMOTIONS = 'SELECT_PROMOTIONS';
export const RESET_CURRENT_PROMOTIONS = 'RESET_CURRENT_PROMOTIONS';
export const REQUEST_PROMOTIONS_DETAIL = 'REQUEST_PROMOTIONS_DETAIL';
export const FETCH_PROMOTIONS_DETAIL_SUCCESS = 'FETCH_PROMOTIONS_DETAIL_SUCCESS';
export const FETCH_PROMOTIONS_DETAIL_FAILURE = 'FETCH_PROMOTIONS_DETAIL_FAILURE';
export const REQUEST_ADDING_PROMOTION = 'REQUEST_ADDING_PROMOTION';
export const ADD_PROMOTION_SUCCESS = 'ADD_PROMOTION_SUCCESS';
export const ADD_PROMOTION_FAILURE = 'ADD_PROMOTION_FAILURE';
export const REQUEST_DELETE_PROMOTION = 'REQUEST_DELETE_PROMOTION';
export const DELETE_PROMOTION_SUCCESS = 'DELETE_PROMOTION_SUCCESS';
export const DELETE_PROMOTION_FAILURE = 'DELETE_PROMOTION_FAILURE';
export const REQUEST_EDITING_PROMOTION = 'REQUEST_EDITING_PROMOTION';
export const EDIT_PROMOTION_SUCCESS = 'EDIT_PROMOTION_SUCCESS';
export const EDIT_PROMOTION_FAILURE = 'EDIT_PROMOTION_FAILURE';
export const REQUEST_SAVE_PROMOTION = 'REQUEST_SAVE_PROMOTION';
export const SAVE_PROMOTION_SUCCESS = 'SAVE_PROMOTION_SUCCESS';
export const SAVE_PROMOTION_FAILURE = 'SAVE_PROMOTION_FAILURE';
export const REQUEST_SAVE_PROMO_NOTES = 'REQUEST_SAVE_PROMO_NOTES';
export const SAVE_PROMO_NOTES_SUCCESS = 'SAVE_PROMO_NOTES_SUCCESS';
export const SAVE_PROMO_NOTES_FAILURE = 'SAVE_PROMO_NOTES_FAILURE';
export const REQUEST_PROMO_NOTES = 'REQUEST_PROMO_NOTES';
export const FETCH_PROMO_NOTES_SUCCESS = 'FETCH_PROMO_NOTES_SUCCESS';
export const FETCH_PROMO_NOTES_FAILURE = 'FETCH_PROMO_NOTES_FAILURE';
export const CLEAR_PROMO_NOTES_STATUS = 'CLEAR_PROMO_NOTES_STATUS';
export const SET_CURRENT_PROMO = 'SET_CURRENT_PROMO';
export const RESET_CURRENT_PROMO = 'RESET_CURRENT_PROMO';
export const REQUEST_PROMO_DETAILS = 'REQUEST_PROMO_DETAILS';
export const FETCH_PROMO_DETAILS_SUCCESS = 'FETCH_PROMO_DETAILS_SUCCESS';
export const FETCH_PROMO_DETAILS_FAILURE = 'FETCH_PROMO_DETAILS_FAILURE';
export const CLEAR_PROMO_DETAIL_STATUS = 'CLEAR_PROMO_DETAIL_STATUS';

// Previous Orders action types
export const REQUEST_PREVIOUSSOS = 'REQUEST_PREVIOUSSOS';
export const REQUEST_PREVIOUSSQS = 'REQUEST_PREVIOUSSQS';
export const FETCH_PREVIOUSSOS_SUCCESS = 'FETCH_PREVIOUSSOS_SUCCESS';
export const FETCH_PREVIOUSSOS_FAILURE = 'FETCH_PREVIOUSSOS_FAILURE';
export const FETCH_PREVIOUSSQS_SUCCESS = 'FETCH_PREVIOUSSQS_SUCCESS';
export const FETCH_PREVIOUSSQS_FAILURE = 'FETCH_PREVIOUSSQS_FAILURE';
export const REQUEST_PREVIOUSSO_DETAIL = 'REQUEST_PREVIOUSSO_DETAIL';
export const FETCH_PREVIOUSSO_DETAIL_SUCCESS = 'FETCH_PREVIOUSSO_DETAIL_SUCCESS';
export const FETCH_PREVIOUSSO_DETAIL_FAILURE = 'FETCH_PREVIOUSSO_DETAIL_FAILURE';
export const REQUEST_PREVIOUSSQ_DETAIL = 'REQUEST_PREVIOUSSQ_DETAIL';
export const FETCH_PREVIOUSSQ_DETAIL_SUCCESS = 'FETCH_PREVIOUSSQ_DETAIL_SUCCESS';
export const FETCH_PREVIOUSSQ_DETAIL_FAILURE = 'FETCH_PREVIOUSSQ_DETAIL_SUCCESS';
export const REQUEST_PREVIOUSORDERS = 'REQUEST_PREVIOUSORDERS';
export const FETCH_PREVIOUSORDERS_SUCCESS = 'FETCH_PREVIOUSORDERS_SUCCESS';
export const FETCH_PREVIOUSORDERS_FAILURE = 'FETCH_PREVIOUSORDERS_FAILURE';
export const SELECT_PREVIOUSORDERS = 'SELECT_PREVIOUSORDERS';
export const RESET_CURRENT_PREVIOUSORDERS = 'RESET_CURRENT_PREVIOUSORDERS';
export const REQUEST_PREVIOUSORDERS_DETAIL = 'REQUEST_PREVIOUSORDERS_DETAIL';
export const FETCH_PREVIOUSORDERS_DETAIL_SUCCESS = 'FETCH_PREVIOUSORDERS_DETAIL_SUCCESS';
export const FETCH_PREVIOUSORDERS_DETAIL_FAILURE = 'FETCH_PREVIOUSORDERS_DETAIL_FAILURE';
export const REQUEST_ADDING_PREVIOUSORDER = 'REQUEST_ADDING_PREVIOUSORDER';
export const ADD_PREVIOUSORDER_SUCCESS = 'ADD_PREVIOUSORDER_SUCCESS';
export const ADD_PREVIOUSORDER_FAILURE = 'ADD_PREVIOUSORDER_FAILURE';
export const REQUEST_DELETE_PREVIOUSORDER = 'REQUEST_DELETE_PREVIOUSORDER';
export const DELETE_PREVIOUSORDER_SUCCESS = 'DELETE_PREVIOUSORDER_SUCCESS';
export const DELETE_PREVIOUSORDER_FAILURE = 'DELETE_PREVIOUSORDER_FAILURE';

// Inventory relocation action types
export const REQUEST_INVENTORY_RELOCATIONS = 'REQUEST_INVENTORY_RELOCATIONS';
export const FETCH_INVENTORY_RELOCATIONS_SUCCESS = 'FETCH_INVENTORY_RELOCATIONS_SUCCESS';
export const FETCH_INVENTORY_RELOCATIONS_FAILURE = 'FETCH_INVENTORY_RELOCATIONS_FAILURE';
export const SELECT_INVENTORY_RELOCATION = 'SELECT_INVENTORY_RELOCATION';
export const RESET_CURRENT_INVENTORY_RELOCATION = 'RESET_CURRENT_INVENTORY_RELOCATION';
export const REQUEST_INVENTORY_RELOCATION_DETAIL = 'REQUEST_INVENTORY_RELOCATION_DETAIL';
export const FETCH_INVENTORY_RELOCATION_DETAIL_SUCCESS = 'FETCH_INVENTORY_RELOCATION_DETAIL_SUCCESS';
export const FETCH_INVENTORY_RELOCATION_DETAIL_FAILURE = 'FETCH_INVENTORY_RELOCATION_DETAIL_FAILURE';

export const REQUEST_CREATING_INVENTORY_RELOCATION = 'REQUEST_CREATING_INVENTORY_RELOCATION';
export const CREATE_INVENTORY_RELOCATION_SUCCESS = 'CREATE_INVENTORY_RELOCATION_SUCCESS';
export const CREATE_INVENTORY_RELOCATION_FAILURE = 'CREATE_INVENTORY_RELOCATION_FAILURE';
export const REQUEST_EDITING_INVENTORY_RELOCATION = 'REQUEST_EDITING_INVENTORY_RELOCATION';
export const EDIT_INVENTORY_RELOCATION_SUCCESS = 'EDIT_INVENTORY_RELOCATION_SUCCESS';
export const EDIT_INVENTORY_RELOCATION_FAILURE = 'EDIT_INVENTORY_RELOCATION_FAILURE';

// Inventory adjustment action types
export const REQUEST_INVENTORY_ADJUSTMENTS = 'REQUEST_INVENTORY_ADJUSTMENTS';
export const REQUEST_INVENTORY_ADJUSTMENTS_DETAIL = 'REQUEST_INVENTORY_ADJUSTMENTS_DETAIL';
export const FETCH_INVENTORY_ADJUSTMENTS_DETAIL_SUCCESS = 'FETCH_INVENTORY_ADJUSTMENTS_DETAIL_SUCCESS';
export const FETCH_INVENTORY_ADJUSTMENTS_DETAIL_FAILURE = 'FETCH_INVENTORY_ADJUSTMENTS_DETAIL_FAILURE';
export const FETCH_INVENTORY_ADJUSTMENTS_SUCCESS = 'FETCH_INVENTORY_ADJUSTMENTS_SUCCESS';
export const FETCH_INVENTORY_ADJUSTMENTS_FAILURE = 'FETCH_INVENTORY_ADJUSTMENTS_FAILURE';
export const SELECT_INVENTORY_ADJUSTMENT = 'SELECT_INVENTORY_ADJUSTMENT';
export const RESET_CURRENT_INVENTORY_ADJUSTMENT = 'RESET_CURRENT_INVENTORY_ADJUSTMENT';
export const REQUEST_INVENTORY_ADJUSTMENT_DETAIL = 'REQUEST_INVENTORY_ADJUSTMENT_DETAIL';
export const FETCH_INVENTORY_ADJUSTMENT_DETAIL_SUCCESS = 'FETCH_INVENTORY_ADJUSTMENT_DETAIL_SUCCESS';
export const FETCH_INVENTORY_ADJUSTMENT_DETAIL_FAILURE = 'FETCH_INVENTORY_ADJUSTMENT_DETAIL_FAILURE';

export const REQUEST_NEW_CONVERT = 'REQUEST_NEW_CONVERT';
export const NEW_CONVERT_SUCCESS = 'NEW_CONVERT_SUCCESS';
export const NEW_CONVERT_FAILURE = 'NEW_CONVERT_FAILURE';

export const REQUEST_CREATING_INVENTORY_ADJUSTMENTS = 'REQUEST_CREATING_INVENTORY_ADJUSTMENTS';
export const CREATE_INVENTORY_ADJUSTMENTS_SUCCESS = 'CREATE_INVENTORY_ADJUSTMENTS_SUCCESS';
export const CREATE_INVENTORY_ADJUSTMENTS_FAILURE = 'CREATE_INVENTORY_ADJUSTMENTS_FAILURE';
export const REQUEST_EDITING_INVENTORY_ADJUSTMENTS = 'REQUEST_EDITING_INVENTORY_ADJUSTMENTS';
export const EDIT_INVENTORY_ADJUSTMENTS_SUCCESS = 'EDIT_INVENTORY_ADJUSTMENTS_SUCCESS';
export const EDIT_INVENTORY_ADJUSTMENTS_FAILURE = 'EDIT_INVENTORY_ADJUSTMENTS_FAILURE';

export const REQUEST_QUICK_INVENTORY_ADJUSTMENTS = 'REQUEST_QUICK_INVENTORY_ADJUSTMENTS';
export const QUICK_INVENTORY_ADJUSTMENTS_SUCCESS = 'QUICK_INVENTORY_ADJUSTMENTS_SUCCESS';
export const QUICK_INVENTORY_ADJUSTMENTS_FAILURE = 'QUICK_INVENTORY_ADJUSTMENTS_FAILURE';
export const RESET_QUICK_INVENTORY_ADJUSTMENTS = 'RESET_QUICK_INVENTORY_ADJUSTMENTS';
// Inventory repackage action types
export const REQUEST_INVENTORY_REPACKAGES = 'REQUEST_INVENTORY_REPACKAGES';
export const FETCH_INVENTORY_REPACKAGES_SUCCESS = 'FETCH_INVENTORY_REPACKAGES_SUCCESS';
export const FETCH_INVENTORY_REPACKAGES_FAILURE = 'FETCH_INVENTORY_REPACKAGES_FAILURE';
export const SELECT_INVENTORY_REPACKAGE = 'SELECT_INVENTORY_REPACKAGE';
export const RESET_CURRENT_INVENTORY_REPACKAGE = 'RESET_CURRENT_INVENTORY_REPACKAGE';
export const REQUEST_INVENTORY_REPACKAGE_DETAIL = 'REQUEST_INVENTORY_REPACKAGE_DETAIL';
export const FETCH_INVENTORY_REPACKAGE_DETAIL_SUCCESS = 'FETCH_INVENTORY_REPACKAGE_DETAIL_SUCCESS';
export const FETCH_INVENTORY_REPACKAGE_DETAIL_FAILURE = 'FETCH_INVENTORY_REPACKAGE_DETAIL_FAILURE';
export const REQUEST_CREATING_INVENTORY_REPACKAGE = 'REQUEST_CREATING_INVENTORY_REPACKAGE';
export const CREATE_INVENTORY_REPACKAGE_SUCCESS = 'CREATE_INVENTORY_REPACKAGE_SUCCESS';
export const CREATE_INVENTORY_REPACKAGE_FAILURE = 'CREATE_INVENTORY_REPACKAGE_FAILURE';
export const REQUEST_EDITING_INVENTORY_REPACKAGE = 'REQUEST_EDITING_INVENTORY_REPACKAGE';
export const EDIT_INVENTORY_REPACKAGE_SUCCESS = 'EDIT_INVENTORY_REPACKAGE_SUCCESS';
export const EDIT_INVENTORY_REPACKAGE_FAILURE = 'EDIT_INVENTORY_REPACKAGE_FAILURE';

// Inventory repackage action types
export const REQUEST_INVENTORY_CONVERTS = 'REQUEST_INVENTORY_CONVERTS';
export const FETCH_INVENTORY_CONVERTS_SUCCESS = 'FETCH_INVENTORY_CONVERTS_SUCCESS';
export const FETCH_INVENTORY_CONVERTS_FAILURE = 'FETCH_INVENTORY_CONVERTS_FAILURE';
export const SELECT_INVENTORY_CONVERT = 'SELECT_INVENTORY_CONVERT';
export const RESET_CURRENT_INVENTORY_CONVERT = 'RESET_CURRENT_INVENTORY_CONVERT';
export const REQUEST_INVENTORY_CONVERT_DETAIL = 'REQUEST_INVENTORY_CONVERT_DETAIL';
export const FETCH_INVENTORY_CONVERT_DETAIL_SUCCESS = 'FETCH_INVENTORY_CONVERT_DETAIL_SUCCESS';
export const FETCH_INVENTORY_CONVERT_DETAIL_FAILURE = 'FETCH_INVENTORY_CONVERT_DETAIL_FAILURE';
export const REQUEST_INVENTORIES_BIN = 'REQUEST_INVENTORIES_BIN';
export const FETCH_INVENTORIES_BIN_SUCCESS = 'FETCH_INVENTORIES_BIN_SUCCESS';
export const FETCH_INVENTORIES_BIN_FAILURE = 'FETCH_INVENTORIES_BIN_FAILURE';
export const REQUEST_CREATING_INVENTORY_CONVERT = 'REQUEST_CREATING_INVENTORY_CONVERT';
export const CREATE_INVENTORY_CONVERT_SUCCESS = 'CREATE_INVENTORY_CONVERT_SUCCESS';
export const CREATE_INVENTORY_CONVERT_FAILURE = 'CREATE_INVENTORY_CONVERT_FAILURE';
export const REQUEST_EDITING_INVENTORY_CONVERT = 'REQUEST_EDITING_INVENTORY_CONVERT';
export const EDIT_INVENTORY_CONVERT_SUCCESS = 'EDIT_INVENTORY_CONVERT_SUCCESS';
export const EDIT_INVENTORY_CONVERT_FAILURE = 'EDIT_INVENTORY_CONVERT_FAILURE';

// Scrap Records action types
export const REQUEST_SCRAP_RECORDS = 'REQUEST_SCRAP_RECORDS';
export const FETCH_SCRAP_RECORDS_SUCCESS = 'FETCH_SCRAP_RECORDS_SUCCESS';
export const FETCH_SCRAP_RECORDS_FAILURE = 'FETCH_SCRAP_RECORDS_FAILURE';
export const SELECT_SCRAP_RECORD = 'SELECT_SCRAP_RECORD';
export const RESET_CURRENT_SCRAP_RECORD = 'RESET_CURRENT_SCRAP_RECORD';
export const REQUEST_SCRAP_RECORD_DETAIL = 'REQUEST_SCRAP_RECORD_DETAIL';
export const FETCH_SCRAP_RECORD_DETAIL_SUCCESS = 'FETCH_SCRAP_RECORD_DETAIL_SUCCESS';
export const FETCH_SCRAP_RECORD_DETAIL_FAILURE = 'FETCH_SCRAP_RECORD_DETAIL_FAILURE';

// Receive action types
export const REQUEST_RECEIVES = 'REQUEST_RECEIVES';
export const FETCH_RECEIVES_SUCCESS = 'FETCH_RECEIVES_SUCCESS';
export const FETCH_RECEIVES_FAILURE = 'FETCH_RECEIVES_FAILURE';
export const SELECT_RECEIVE = 'SELECT_RECEIVE';
export const RESET_CURRENT_RECEIVE = 'RESET_CURRENT_RECEIVE';
export const REQUEST_CREATING_RECEIVE = 'REQUEST_CREATING_RECEIVE';
export const CREATE_RECEIVE_SUCCESS = 'CREATE_RECEIVE_SUCCESS';
export const CREATE_RECEIVE_FAILURE = 'CREATE_RECEIVE_FAILURE';
export const RESET_CREATE_RECEIVE = 'RESET_CREATE_RECEIVE';
export const REQUEST_EDITING_RECEIVE = 'REQUEST_EDITING_RECEIVE';
export const EDIT_RECEIVE_SUCCESS = 'EDIT_RECEIVE_SUCCESS';
export const EDIT_RECEIVE_FAILURE = 'EDIT_RECEIVE_FAILURE';
export const REQUEST_RECEIVE_DETAIL = 'REQUEST_RECEIVE_DETAIL';
export const FETCH_RECEIVE_DETAIL_SUCCESS = 'FETCH_RECEIVE_DETAIL_SUCCESS';
export const FETCH_RECEIVE_DETAIL_FAILURE = 'FETCH_RECEIVE_DETAIL_FAILURE';
export const FETCH_RECEIVE_HISTORY = 'FETCH_RECEIVE_HISTORY';
export const FETCH_RECEIVE_HISTORY_SUCCESS = 'FETCH_RECEIVE_HISTORY_SUCCESS';
export const FETCH_RECEIVE_HISTORY_FAILURE = 'FETCH_RECEIVE_HISTORY_FAILURE';
export const SELECT_RECEIVE_HISTORY = 'SELECT_RECEIVE_HISTORY';
export const RESET_CURRENT_RECEIVE_HISTORY = 'RESET_CURRENT_RECEIVE_HISTORY';

export const FETCH_RECEIVE_HISTORY_DETAIL = 'FETCH_RECEIVE_HISTORY_DETAIL';
export const FETCH_RECEIVE_HISTORY_DETAIL_SUCCESS = 'FETCH_RECEIVE_HISTORY_DETAIL_SUCCESS';
export const FETCH_RECEIVE_HISTORY_DETAIL_FAILURE = 'FETCH_RECEIVE_HISTORY_DETAIL_FAILURE';

export const FETCH_ALL_RECEIVE_HISTORY_DETAIL = 'FETCH_ALL_RECEIVE_HISTORY_DETAIL';
export const FETCH_ALL_RECEIVE_HISTORY_DETAIL_SUCCESS = 'FETCH_ALL_RECEIVE_HISTORY_DETAIL_SUCCESS';
export const FETCH_ALL_RECEIVE_HISTORY_DETAIL_FAILURE = 'FETCH_ALL_RECEIVE_HISTORY_DETAIL_FAILURE';
export const FETCH_RECEIVE_HISTORY_DETAIL_RECORD = 'FETCH_RECEIVE_HISTORY_DETAIL_RECORD';
export const FETCH_RECEIVE_HISTORY_DETAIL_RECORD_SUCCESS = 'FETCH_RECEIVE_HISTORY_DETAIL_RECORD_SUCCESS';
export const FETCH_RECEIVE_HISTORY_DETAIL_RECORD_FAILURE = 'FETCH_RECEIVE_HISTORY_DETAIL_RECORD_FAILURE';

export const REQUEST_EDITING_RECEIVE_HISTORY = 'REQUEST_EDITING_RECEIVE_HISTORY';
export const EDIT_RECEIVE_HISTORY_SUCCESS = 'EDIT_RECEIVE_HISTORY_SUCCESS';
export const EDIT_RECEIVE_HISTORY_FAILURE = 'EDIT_RECEIVE_HISTORY_FAILURE';
export const RESET_EDIT_RECEIVE_HISTORY = 'RESET_EDIT_RECEIVE_HISTORY';

export const DELETE_RECEIVE = 'DELETE_RECEIVE';
export const DELETE_RECEIVE_FINISHED = 'DELETE_RECEIVE_FINISHED';
export const RESET_DELETE_STATUS = 'RESET_DELETE_STATUS';
export const SET_RECEIVE_SELECTED_ROWS = 'SET_RECEIVE_SELECTED_ROWS';
export const SET_RECEIVE_PAGINATION_FILTER = 'SET_RECEIVE_PAGINATION_FILTER';
export const SET_RECEIVE_SCROLL_TOP_POSITION_INDEX = 'SET_RECEIVE_SCROLL_TOP_POSITION_INDEX';

// Warehouse action types
export const SALES_ORDER_FORM_BATCHES = 'SALES_ORDER_FORM_BATCHES';
export const REQUEST_WAREHOUSES = 'REQUEST_WAREHOUSES';
export const FETCH_WAREHOUSES_SUCCESS = 'FETCH_WAREHOUSES_SUCCESS';
export const FETCH_WAREHOUSES_FAILURE = 'FETCH_WAREHOUSES_FAILURE';
export const RESET_WAREHOUSES = 'RESET_WAREHOUSES';
export const SELECT_WAREHOUSE = 'SELECT_WAREHOUSE';
export const RESET_CURRENT_WAREHOUSE = 'RESET_CURRENT_WAREHOUSE';
export const REQUEST_WAREHOUSE_DETAIL = 'REQUEST_WAREHOUSE_DETAIL';
export const FETCH_WAREHOUSE_DETAIL_SUCCESS = 'FETCH_WAREHOUSE_DETAIL_SUCCESS';
export const FETCH_WAREHOUSE_DETAIL_FAILURE = 'FETCH_WAREHOUSE_DETAIL_FAILURE';
export const REQUEST_CREATING_WAREHOUSE = 'REQUEST_CREATING_WAREHOUSE';
export const CREATE_WAREHOUSE_SUCCESS = 'CREATE_WAREHOUSE_SUCCESS';
export const CREATE_WAREHOUSE_FAILURE = 'CREATE_WAREHOUSE_FAILURE';
export const REQUEST_EDITING_WAREHOUSE = 'REQUEST_EDITING_WAREHOUSE';
export const EDIT_WAREHOUSE_SUCCESS = 'EDIT_WAREHOUSE_SUCCESS';
export const EDIT_WAREHOUSE_FAILURE = 'EDIT_WAREHOUSE_FAILURE';
export const REQUEST_DELETE_WAREHOUSE = 'REQUEST_DELETE_WAREHOUSE';
export const DELETE_WAREHOUSE_SUCCESS = 'DELETE_WAREHOUSE_SUCCESS';
export const DELETE_WAREHOUSE_FAILURE = 'DELETE_WAREHOUSE_FAILURE';

// Zone action types
export const REQUEST_ZONES = 'REQUEST_ZONES';
export const FETCH_ZONES_SUCCESS = 'FETCH_ZONES_SUCCESS';
export const FETCH_ZONES_FAILURE = 'FETCH_ZONES_FAILURE';
export const SELECT_ZONE = 'SELECT_ZONE';
export const RESET_CURRENT_ZONE = 'RESET_CURRENT_ZONE';
export const REQUEST_ZONE_DETAIL = 'REQUEST_ZONE_DETAIL';
export const FETCH_ZONE_DETAIL_SUCCESS = 'FETCH_ZONE_DETAIL_SUCCESS';
export const FETCH_ZONE_DETAIL_FAILURE = 'FETCH_ZONE_DETAIL_FAILURE';
export const REQUEST_CREATING_ZONE = 'REQUEST_CREATING_ZONE';
export const CREATE_ZONE_SUCCESS = 'CREATE_ZONE_SUCCESS';
export const CREATE_ZONE_FAILURE = 'CREATE_ZONE_FAILURE';
export const REQUEST_EDITING_ZONE = 'REQUEST_EDITING_ZONE';
export const EDIT_ZONE_SUCCESS = 'EDIT_ZONE_SUCCESS';
export const EDIT_ZONE_FAILURE = 'EDIT_ZONE_FAILURE';
export const REQUEST_BINS = 'REQUEST_BINS';
export const FETCH_BINS_SUCCESS = 'FETCH_BINS_SUCCESS';
export const FETCH_BINS2_SUCCESS = 'FETCH_BINS2_SUCCESS';
export const FETCH_BINS3_SUCCESS = 'FETCH_BINS3_SUCCESS';
export const FETCH_BINS_FAILURE = 'FETCH_BINS_FAILURE';
export const RESET_BINS = 'RESET_BINS';
export const SELECT_BIN = 'SELECT_BIN';
export const RESET_CURRENT_BIN = 'RESET_CURRENT_BIN';
export const REQUEST_BIN_DETAIL = 'REQUEST_BIN_DETAIL';
export const FETCH_BIN_DETAIL_SUCCESS = 'FETCH_BIN_DETAIL_SUCCESS';
export const FETCH_BIN_DETAIL_FAILURE = 'FETCH_BIN_DETAIL_FAILURE';
export const REQUEST_CREATING_BIN = 'REQUEST_CREATING_BIN';
export const CREATE_BIN_SUCCESS = 'CREATE_BIN_SUCCESS';
export const CREATE_BIN_FAILURE = 'CREATE_BIN_FAILURE';
export const REQUEST_EDITING_BIN = 'REQUEST_EDITING_BIN';
export const EDIT_BIN_SUCCESS = 'EDIT_BIN_SUCCESS';
export const EDIT_BIN_FAILURE = 'EDIT_BIN_FAILURE';
export const REQUEST_DELETE_ZONE = 'REQUEST_DELETE_ZONE';
export const DELETE_ZONE_SUCCESS = 'DELETE_ZONE_SUCCESS';
export const DELETE_ZONE_FAILURE = 'DELETE_ZONE_FAILURE';
export const REQUEST_DELETE_BIN = 'REQUEST_DELETE_BIN';
export const DELETE_BIN_SUCCESS = 'DELETE_BIN_SUCCESS';
export const DELETE_BIN_FAILURE = 'DELETE_BIN_FAILURE';
export const FETCH_LEVELS = "FETCH_LEVELS";
export const FETCH_LEVELS_SUCCESS = "FETCH_LEVELS_SUCCESS";
export const FETCH_LEVELS2_SUCCESS = "FETCH_LEVELS2_SUCCESS";
export const FETCH_LEVELS3_SUCCESS = "FETCH_LEVELS3_SUCCESS";
export const FETCH_LEVELS_ERROR = "FETCH_LEVELS_FAILURE";
export const CREATE_BARCODE = "CREATE_BARCODE";
export const CREATE_BARCODE_SUCCESS = "CREATE_BARCODE_SUCCESS";
export const CREATE_BARCODE_FAILURE = "CREATE_BARCODE_FAILURE";
export const SELECT_LEVEL = 'SELECT_LEVEL';
export const REQUEST_EDITING_LEVEL = 'REQUEST_EDITING_LEVEL';
export const EDITING_LEVEL_SUCCESS = 'EDITING_LEVEL_SUCCESS';
export const EDITING_LEVEL_FAILURE = 'EDITING_LEVEL_FAILURE';
export const CREATE_LEVEL_REQUEST = 'CREATE_LEVEL_REQUEST;'
export const CREATE_LEVEL_SUCCESS = 'CREATE_LEVEL_SUCCESS';
export const CREATE_LEVEL_FAILURE = 'CREATE_LEVEL_FAILURE';
export const ATTACH_ZONE_BIN_LEVEL = 'ATTACH_ZONE_BIN_LEVEL';
export const ATTACH_ZONE_BIN_LEVEL_SUCCESS = 'ATTACH_ZONE_BIN_LEVEL_SUCCESS';
export const ATTACH_ZONE_BIN_LEVEL_FAILURE = 'ATTACH_ZONE_BIN_LEVEL_FAILURE';
export const REQUEST_DELETE_LEVEL = 'REQUEST_DELETE_LEVEL';
export const DELETE_LEVEL_SUCCESS = 'DELETE_LEVEL_SUCCESS';
export const DELETE_LEVEL_FAILURE = 'DELETE_LEVEL_FAILURE';

// Sales Order action types
export const REQUEST_PRODUCT_BATCHES = 'REQUEST_PRODUCT_BATCHES';
export const SALES_RETURN_PDF = 'SALES_RETURN_PDF';
export const REQUEST_SALES_ORDERS = 'REQUEST_SALES_ORDERS';
export const FETCH_SALES_ORDERS_SUCCESS = 'FETCH_SALES_ORDERS_SUCCESS';
export const FETCH_SALES_ORDERS_FAILURE = 'FETCH_SALES_ORDERS_FAILURE';
export const REQUEST_SALES_ORDERS_BY_FILTER = 'REQUEST_SALES_ORDERS_BY_FILTER';
export const SELECT_SALES_ORDER = 'SELECT_SALES_ORDER';
export const RESET_CURRENT_SALES_ORDER = 'RESET_CURRENT_SALES_ORDER';
export const REQUEST_SALES_ORDER_DETAIL = 'REQUEST_SALES_ORDER_DETAIL';
export const FETCH_SALES_ORDER_DETAIL_SUCCESS = 'FETCH_SALES_ORDER_DETAIL_SUCCESS';
export const FETCH_SALES_ORDER_DETAIL_FAILURE = 'FETCH_SALES_ORDER_DETAIL_FAILURE';
export const REQUEST_SALES_ORDER_DETAIL_BY_NUM = 'REQUEST_SALES_ORDER_DETAIL_BY_NUM';
export const FETCH_SALES_ORDER_DETAIL_BY_NUM_SUCCESS = 'FETCH_SALES_ORDER_DETAIL_BY_NUM_SUCCESS';
export const FETCH_SALES_ORDER_DETAIL_BY_NUM_FAILURE = 'FETCH_SALES_ORDER_DETAIL_BY_NUM_FAILURE';
export const REQUEST_CREATING_SALES_ORDER = 'REQUEST_CREATING_SALES_ORDER';
export const CREATE_SALES_ORDER_SUCCESS = 'CREATE_SALES_ORDER_SUCCESS';
export const CREATE_SALES_ORDER_FAILURE = 'CREATE_SALES_ORDER_FAILURE';
export const REQUEST_EDITING_SALES_ORDER = 'REQUEST_EDITING_SALES_ORDER';
export const EDIT_SALES_ORDER_SUCCESS = 'EDIT_SALES_ORDER_SUCCESS';
export const EDIT_SALES_ORDER_FAILURE = 'EDIT_SALES_ORDER_FAILURE';
export const REQUEST_SALES_INVENTORY_INFO = 'REQUEST_SALES_INVENTORY_INFO';
export const FETCH_SALES_INVENTORY_INFO_SUCCESS = 'FETCH_SALES_INVENTORY_INFO_SUCCESS';
export const FETCH_SALES_INVENTORY_INFO_FAILURE = 'FETCH_SALES_INVENTORY_INFO_FAILURE';
export const REQUEST_SALES_CUSTOMER_DETAIL = 'REQUEST_SALES_CUSTOMER_DETAIL';
export const REQUEST_SALES_SHIPPING_CUSTOMER_DETAIL = 'REQUEST_SALES_SHIPPING_CUSTOMER_DETAIL';
export const FETCH_SALES_SHIPPING_CUSTOMER_DETAIL_SUCCESS = 'FETCH_SALES_SHIPPING_CUSTOMER_DETAIL_SUCCESS';
export const FETCH_SALES_CUSTOMER_DETAIL_SUCCESS = 'FETCH_SALES_CUSTOMER_DETAIL_SUCCESS';
export const FETCH_SALES_CUSTOMER_DETAIL_FAILURE = 'FETCH_SALES_CUSTOMER_DETAIL_FAILURE';
export const REQUEST_SHIPPING_DETAIL = 'REQUEST_SHIPPING_DETAIL';
export const FETCH_SHIPPING_DETAIL_SUCCESS = 'FETCH_SHIPPING_DETAIL_SUCCESS';
export const FETCH_SHIPPING_DETAIL_FAILURE = 'FETCH_SHIPPING_DETAIL_FAILURE';
export const REQUEST_PURCHASES_VENDOR_DETAIL = 'REQUEST_PURCHASES_VENDOR_DETAIL';
export const FETCH_PURCHASES_VENDOR_DETAIL_SUCCESS = 'FETCH_PURCHASES_VENDOR_DETAIL_SUCCESS';
export const FETCH_PURCHASES_VENDOR_DETAIL_FAILURE = 'FETCH_PURCHASES_VENDOR_DETAIL_FAILURE';
export const CLEAR_SALES_CUSTOMER_DETAILS = 'CLEAR_SALES_CUSTOMER_DETAILS';
export const SET_SALES_ORDERS_FILTER = 'SET_SALES_ORDERS_FILTER';
export const SET_SALES_ORDERS_PAGINATION_FILTER = 'SET_SALES_ORDERS_PAGINATION_FILTER';
export const REQUEST_ITEM_SALES_HISTORY = 'REQUEST_ITEM_SALES_HISTORY';
export const REQUEST_ITEM_PURCHASE_HISTORY = 'REQUEST_ITEM_PURCHASE_HISTORY';
export const FETCH_ITEM_SALES_HISTORY_SUCCESS = 'FETCH_ITEM_SALES_HISTORY_SUCCESS';
export const FETCH_ITEM_PURCHASE_HISTORY_SUCCESS = 'FETCH_ITEM_PURCHASE_HISTORY_SUCCESS'
export const FETCH_ITEM_SALES_HISTORY_FAILURE = 'FETCH_ITEM_SALES_HISTORY_FAILURE';
export const FETCH_ITEM_PURCHASE_HISTORY_FAILURE = 'FETCH_ITEM_PURCHASE_HISTORY_FAILURE';
export const REQUEST_CUSTOMER_FREQUENT = 'REQUEST_CUSTOMER_FREQUENT';
export const FETCH_CUSTOMER_FREQUENT_SUCCESS = 'FETCH_CUSTOMER_FREQUENT_SUCCESS';
export const FETCH_CUSTOMER_FREQUENT_FAILURE = 'FETCH_CUSTOMER_FREQUENT_FAILURE';
export const REQUEST_WHOLESALE = 'REQUEST_WHOLESALE';
export const FETCH_WHOLESALE_SUCCESS = 'FETCH_WHOLESALE_SUCCESS';
export const FETCH_WHOLESALE_FAILURE = 'FETCH_WHOLESALE_FAILURE';
export const SELECT_WHOLESALE = 'SELECT_WHOLESALE';
export const RESET_CURRENT_WHOLESALE = 'RESET_CURRENT_WHOLESALE';
export const REQUEST_WHOLESALE_DETAIL = 'REQUEST_WHOLESALE_DETAIL';
export const FETCH_WHOLESALE_DETAIL_SUCCESS = 'FETCH_WHOLESALE_DETAIL_SUCCESS';
export const FETCH_WHOLESALE_DETAIL_FAILURE = 'FETCH_WHOLESALE_DETAIL_FAILURE';
export const REQUEST_CREATING_WHOLESALE = 'REQUEST_CREATING_WHOLESALE';
export const CREATE_WHOLESALE_SUCCESS = 'CREATE_WHOLESALE_SUCCESS';
export const CREATE_WHOLESALE_FAILURE = 'CREATE_WHOLESALE_FAILURE';
export const REQUEST_EDITING_WHOLESALE = 'REQUEST_EDITING_WHOLESALE';
export const EDIT_WHOLESALE_SUCCESS = 'EDIT_WHOLESALE_SUCCESS';
export const EDIT_WHOLESALE_FAILURE = 'EDIT_WHOLESALE_FAILURE';
export const REQUEST_VOID_SALES_ORDER = 'REQUEST_VOID_SALES_ORDER';
export const VOID_SALES_ORDER_SUCCESS = 'VOID_SALES_ORDER_SUCCESS';
export const VOID_SALES_ORDER_FAILURE = 'VOID_SALES_ORDER_FAILURE';
export const REQUEST_WAREHOUSE_SALES_ORDERS = 'REQUEST_WAREHOUSE_SALES_ORDERS';
export const FETCH_WAREHOUSE_SALES_ORDERS_SUCCESS = 'FETCH_WAREHOUSE_SALES_ORDERS_SUCCESS';
export const FETCH_WAREHOUSE_SALES_ORDERS_FAILURE = 'FETCH_WAREHOUSE_SALES_ORDERS_FAILURE';
export const REQUEST_WAREHOUSE_PURCHASE_ORDERS = 'REQUEST_WAREHOUSE_PURCHASE_ORDERS';
export const FETCH_WAREHOUSE_PURCHASE_ORDERS_SUCCESS = 'FETCH_WAREHOUSE_PURCHASE_ORDERS_SUCCESS';
export const FETCH_WAREHOUSE_PURCHASE_ORDERS_FAILURE = 'FETCH_WAREHOUSE_PURCHASE_ORDERS_FAILURE';
export const REQUEST_WAREHOUSE_BINS = 'REQUEST_WAREHOUSE_BINS';
export const FETCH_WAREHOUSE_BINS_SUCCESS = 'FETCH_WAREHOUSE_BINS_SUCCESS';
export const FETCH_WAREHOUSE_BINS_FAILURE = 'FETCH_WAREHOUSE_BINS_FAILURE';
export const REQUEST_CUSTOMER_SALES_HISTORY = 'REQUEST_CUSTOMER_ORDER_SCHEDULES';
export const FETCH_CUSTOMER_SALES_HISTORY_SUCCESS = 'FETCH_CUSTOMER_SALES_HISTORY_SUCCESS';
export const FETCH_CUSTOMER_SALES_HISTORY_FAILURE = 'FETCH_CUSTOMER_SALES_HISTORY_FAILURE';
export const REQUEST_CUSTOMER_ORDER_SCHEDULES = 'REQUEST_CUSTOMER_ORDER_SCHEDULES';
export const FETCH_CUSTOMER_ORDER_SCHEDULES_SUCCESS = 'FETCH_CUSTOMER_ORDER_SCHEDULES_SUCCESS';
export const FETCH_CUSTOMER_ORDER_SCHEDULES_FAILURE = 'FETCH_CUSTOMER_ORDER_SCHEDULES_FAILURE';
export const REQUEST_TODAYS_OUTGOING_ORDERS = 'REQUEST_TODAYS_OUTGOING_ORDERS';
export const FETCH_TODAYS_OUTGOING_ORDERS_SUCCESS = 'FETCH_TODAYS_OUTGOING_ORDERS_SUCCESS';
export const FETCH_TODAYS_OUTGOING_ORDERS_FAILURE = 'FETCH_TODAYS_OUTGOING_ORDERS_FAILURE';
export const REQUEST_SALES_ORDER_LINE_WEIGHTS = 'REQUEST_SALES_ORDER_LINE_WEIGHTS';
export const FETCH_SALES_ORDER_LINE_WEIGHTS_SUCCESS = 'FETCH_SALES_ORDER_LINE_WEIGHTS_SUCCESS';
export const FETCH_SALES_ORDER_LINE_WEIGHTS_FAILURE = 'FETCH_SALES_ORDER_LINE_WEIGHTS_FAILURE';
export const REQUEST_SET_ORDER_LINE_WEIGHTS = 'REQUEST_SET_ORDER_LINE_WEIGHTS';
export const EDIT_SALES_ORDER_LINE_WEIGHTS_SUCCESS = 'EDIT_SALES_ORDER_LINE_WEIGHTS_SUCCESS';
export const EDIT_SALES_ORDER_LINE_WEIGHTS_FAILURE = 'EDIT_SALES_ORDER_LINE_WEIGHTS_FAILURE';
export const CLEAR_SALES_ORDER_LINE_WEIGHTS = 'CLEAR_SALES_ORDER_LINE_WEIGHTS';
export const REQUEST_SET_SHIPPING_WEIGHT = 'REQUEST_SET_SHIPPING_WEIGHT';
export const UPDATE_SHIPPING_WEIGHT_SUCCESS = 'UPDATE_SHIPPING_WEIGHT_SUCCESS';
export const UPDATE_SHIPPING_WEIGHT_FAILURE = 'UPDATE_SHIPPING_WEIGHT_FAILURE';
export const REQUEST_SET_SHIPPING_WEIGHT_SPLIT = 'REQUEST_SET_SHIPPING_WEIGHT_SPLIT';
export const UPDATE_CURRENT_SALES_ORDER_DETAIL_SHIPPINGINFO = "UPDATE_CURRENT_SALES_ORDER_DETAIL_SHIPPINGINFO";
export const REQUEST_SALES_ORDER_FORM = 'REQUEST_SALES_ORDER_FORM';
export const FETCH_SALES_ORDER_FORM_SUCCESS = 'FETCH_SALES_ORDER_FORM_SUCCESS';
export const FETCH_SALES_ORDER_FORM_FAILURE = 'FETCH_SALES_ORDER_FORM_FAILURE';
export const CLEAR_INVENTORIES = 'CLEAR_INVENTORIES';
export const REQUEST_SALES_CSV = 'REQUEST_SALES_CSV';
export const FETCH_SALES_CSV_SUCCESS = 'FETCH_SALES_CSV_SUCCESS';
export const FETCH_SALES_CSV_FAILURE = 'FETCH_SALES_CSV_FAILURE';
export const REQUEST_SAVE_POS_SALE = 'REQUEST_SAVE_POS_SALE';
export const SAVE_POS_SALE_SUCCESS = 'SAVE_POS_SALE_SUCCESS';
export const SAVE_POS_SALE_FAILURE = 'SAVE_POS_SALE_FAILURE';
export const INVALID_CHARACTER_ENTERED = 'INVALID_CHARACTER_ENTERED';
export const CLEAR_ERROR_MESSAGE_IN_POS = 'CLEAR_ERROR_MESSAGE_IN_POS';
export const REQUEST_POS_ORDERS = 'REQUEST_POS_ORDERS';
export const FETCH_POS_ORDERS_SUCCESS = 'FETCH_POS_ORDERS_SUCCESS';
export const FETCH_POS_ORDERS_FAILURE = 'FETCH_POS_ORDERS_FAILURE';
export const REQUEST_POS_ORDER_DETAIL = 'REQUEST_POS_ORDER_DETAIL';
export const FETCH_POS_ORDER_DETAIL_SUCCESS = 'FETCH_POS_ORDER_DETAIL_SUCCESS';
export const FETCH_POS_ORDER_DETAIL_FAILURE = 'FETCH_POS_ORDER_DETAIL_FAILURE';
export const REQUEST_VOID_POS_ORDER = 'REQUEST_VOID_POS_ORDER';
export const VOID_POS_ORDER_SUCCESS = 'VOID_POS_ORDER_SUCCESS';
export const VOID_POS_ORDER_FAILURE = 'VOID_POS_ORDER_FAILURE';
export const REQUEST_POS_CREDITS = 'REQUEST_POS_CREDITS';
export const FETCH_POS_CREDITS_SUCCESS = 'FETCH_POS_CREDITS_SUCCESS';
export const FETCH_POS_CREDITS_FAILURE = 'FETCH_POS_CREDITS_FAILURE';
export const REQUEST_POS_CREDIT_DETAIL = 'REQUEST_POS_CREDIT_DETAIL';
export const FETCH_POS_CREDIT_DETAIL_SUCCESS = 'FETCH_POS_CREDIT_DETAIL_SUCCESS';
export const FETCH_POS_CREDIT_DETAIL_FAILURE = 'FETCH_POS_CREDIT_DETAIL_FAILURE';
export const REQUEST_EDIT_POS_PAYMENT = 'REQUEST_EDIT_POS_PAYMENT';
export const EDIT_POS_PAYMENT_SUCCESS = 'EDIT_POS_PAYMENT_SUCCESS';
export const EDIT_POS_PAYMENT_FAILURE = 'EDIT_POS_PAYMENT_FAILURE';
export const FETCH_POS_HOLDS_SUCCESS = 'FETCH_POS_HOLDS_SUCCESS';
export const FETCH_POS_HOLDS_DETAILS_SUCCESS = 'FETCH_POS_HOLDS_DETAILS_SUCCESS';
export const CHARGE_NOT_MET = 'CHARGE_NOT_MET';
export const START_NEW_ORDER = 'START_NEW_ORDER';
export const REQUEST_DRAFT_DETAILS = 'REQUEST_DRAFT_DETAILS';
export const LOAD_DRAFT_SUCCESS = 'LOAD_DRAFT_SUCCESS';
export const LOAD_DRAFT_FAILURE = 'LOAD_DRAFT_FAILURE';
export const REQUEST_DRAFTS = 'REQUEST_DRAFTS';
export const FETCH_DRAFTS_SUCCESSFUL = 'FETCH_DRAFTS_SUCCESSFUL';
export const FETCH_DRAFTS_FAILURE = 'FETCH_DRAFTS_FAILURE';
export const REQUEST_CREATING_SALES_RETURN = 'REQUEST_CREATING_SALES_RETURN';
export const CREATE_SALES_RETURN_SUCCESS = 'CREATE_SALES_RETURN_SUCCESS';
export const CREATE_SALES_RETURN_FAILURE = 'CREATE_SALES_RETURN_FAILURE';
export const REQUEST_SALES_RETURN_DETAIL = 'REQUEST_SALES_RETURN_DETAIL';
export const FETCH_SALES_RETURN_DETAIL_SUCCESS = 'FETCH_SALES_RETURN_DETAIL_SUCCESS';
export const FETCH_SALES_RETURN_DETAIL_FAILURE = 'FETCH_SALES_RETURN_DETAIL_FAILURE';
export const REQUEST_SALES_INVOICES_COMPLETED = 'REQUEST_SALES_INVOICES_COMPLETED';
export const FETCH_SALES_INVOICES_COMPLETED_SUCCESS = 'FETCH_SALES_INVOICES_COMPLETED_SUCCESS';
export const FETCH_SALES_INVOICES_COMPLETED_FAILURE = 'FETCH_SALES_INVOICES_COMPLETED_FAILURE';
export const REQUEST_SALES_ORDER_TO_QUOTE = 'REQUEST_SALES_ORDER_TO_QUOTE';
export const SALES_ORDER_TO_QUOTE_SUCCESS = 'SALES_ORDER_TO_QUOTE_SUCCESS';
export const SALES_ORDER_TO_QUOTE_FAILURE = 'SALES_ORDER_TO_QUOTE_FAILURE';
export const REQUEST_SALES_QUOTE_TO_OPEN = 'REQUEST_SALES_QUOTE_TO_OPEN';
export const REQUEST_SALES_QUOTE_TO_ORDER_SUCCESS = 'REQUEST_SALES_QUOTE_TO_ORDER_SUCCESS';
export const REQUEST_SALES_QUOTE_TO_ORDER_FAILURE = 'REQUEST_SALES_QUOTE_TO_ORDER_FAILURE';
export const REQUEST_CUSTOMER_ITEM = 'REQUEST_CUSTOMER_ITEM';
export const FETCH_CUSTOMER_ITEM_SUCCESS = 'FETCH_CUSTOMER_ITEM_SUCCESS';
export const FETCH_CUSTOMER_ITEM_FAILURE = 'FETCH_CUSTOMER_ITEM_FAILURE';
export const REQUEST_INVENTORY_RETURN = 'REQUEST_INVENTORY_RETURN';
export const FETCH_INVENTORY_RETURN_SUCCESS = 'FETCH_INVENTORY_RETURN_SUCCESS';
export const FETCH_INVENTORY_RETURN_FAILURE = 'FETCH_INVENTORY_RETURN_FAILURE';
export const REQUEST_INVENTORY_RETURN_DETAILS = 'REQUEST_INVENTORY_RETURN_DETAILS';
export const FETCH_INVENTORY_RETURN_DETAILS_SUCCESS = 'FETCH_INVENTORY_RETURN_DETAILS_SUCCESS';
export const FETCH_INVENTORY_RETURN_DETAILS_FAILURE = 'FETCH_INVENTORY_RETURN_DETAILS_FAILURE';
export const EDIT_INVENTORY_RETURN = 'EDIT_INVENTORY_RETURN';
export const EDIT_INVENTORY_RETURN_SUCCESS = 'EDIT_INVENTORY_RETURN_SUCCESS';
export const EDIT_INVENTORY_RETURN_FAILURE = 'EDIT_INVENTORY_RETURN_FAILURE';
export const REQUEST_CUSTOMER_PRICES = 'REQUEST_CUSTOMER_PRICES';
export const FETCH_CUSTOMER_PRICES_SUCCESS = 'FETCH_CUSTOMER_PRICES_SUCCESS';
export const FETCH_CUSTOMER_PRICES_FAILURE = 'FETCH_CUSTOMER_PRICES_FAILURE';
export const REQUEST_CURRENCY_RATES = 'REQUEST_CURRENCY_RATES';
export const FETCH_CURRENCY_RATES_SUCCESS = 'FETCH_CURRENCY_RATES_SUCCESS';
export const FETCH_CURRENCY_RATES_FAILURE = 'FETCH_CURRENCY_RATES_FAILURE';
export const EDIT_MULTI_CURRENCIES = 'EDIT_MULTI_CURRENCIES';
export const EDIT_MULTI_CURRENCIES_SUCCESS = 'EDIT_MULTI_CURRENCIES_SUCCESS';
export const EDIT_MULTI_CURRENCIES_FAILURE = 'EDIT_MULTI_CURRENCIES_FAILURE';
export const REQUEST_TAX_RATES = 'REQUEST_TAX_RATES';
export const FETCH_TAX_RATES_SUCCESS = 'FETCH_TAX_RATES_SUCCESS';
export const FETCH_TAX_RATES_FAILURE = 'FETCH_TAX_RATES_FAILURE';
export const REQUEST_CREATE_TAX_RATE = 'REQUEST_CREATE_TAX_RATE';
export const CREATE_TAX_RATE_SUCCESS = 'CREATE_TAX_RATE_SUCCESS';
export const CREATE_TAX_RATE_FAILURE = 'CREATE_TAX_RATE_FAILURE';
export const REQUEST_OVERALL_SALES_PERFORMANCE = 'REQUEST_OVERALL_SALES_PERFORMANCE';
export const FETCH_OVERALL_SALES_PERFORMANCE_SUCCESS = 'FETCH_OVERALL_SALES_PERFORMANCE_SUCCESS';
export const FETCH_OVERALL_SALES_PERFORMANCE_FAILURE = 'FETCH_OVERALL_SALES_PERFORMANCE_FAILURE';
export const REQUEST_SALES_ORDER_INVENTORY = 'REQUEST_SALES_ORDER_INVENTORY';
export const FETCH_SALES_ORDER_INVENTORY_SUCCESS = 'FETCH_SALES_ORDER_INVENTORY_SUCCESS';
export const FETCH_SALES_ORDER_INVENTORY_FAILURE = 'FETCH_SALES_ORDER_INVENTORY_FAILURE';
export const REQUEST_POS_REPORT = 'REQUEST_POS_REPORT';
export const FETCH_POS_REPORT_SUCCESS = 'FETCH_POS_REPORT_SUCCESS';
export const FETCH_POS_REPORT_FAILURE = 'FETCH_POS_REPORT_FAILURE';
export const REQUEST_SALES_PERFORMANCE = 'REQUEST_SALES_PERFORMANCE';
export const REQUEST_SALES_PERFORMANCE_BY_FILTER = 'REQUEST_SALES_PERFORMANCE_BY_FILTER';
export const REQUEST_SALES_PERFORMANCE_SUCCESS = 'REQUEST_SALES_PERFORMANCE_SUCCESS';
export const REQUEST_SALES_PERFORMANCE_FAILURE = 'REQUEST_SALES_PERFORMANCE_FAILURE';
export const REQUEST_USER_PERFORMANCE_BY_FILTER = 'REQUEST_USER_PERFORMANCE_BY_FILTER';
export const REQUEST_USER_PERFORMANCE_SUCCESS = 'REQUEST_USER_PERFORMANCE_SUCCESS';
export const REQUEST_USER_PERFORMANCE_FAILURE = 'REQUEST_USER_PERFORMANCE_FAILURE';
export const REQUEST_SALES_DASHBOARD_DETAIL = 'REQUEST_SALES_DASHBOARD_DETAIL';
export const FETCH_SALES_DASHBOARD_DETAIL_SUCCESS = 'FETCH_SALES_DASHBOARD_DETAIL_SUCCESS';
export const FETCH_SALES_DASHBOARD_DETAIL_FAILURE = 'FETCH_SALES_DASHBOARD_DETAIL_FAILURE';
export const REQUEST_SALES_LEVELS = 'REQUEST_SALES_LEVELS';
export const FETCH_SALES_LEVELS_SUCCESS = 'FETCH_SALES_LEVELS_SUCCESS';
export const FETCH_SALES_LEVELS_FAILURE = 'FETCH_SALES_LEVELS_FAILURE';
export const REQUEST_REFUND = 'REQUEST_REFUND';
export const REQUEST_REFUND_SUCCESS = 'REQUEST_REFUND_SUCCESS';
export const REQUEST_REFUND_FAILURE = 'REQUEST_REFUND_FAILURE';
export const REQUEST_REFUND_PDF = 'REQUEST_REFUND_PDF';
export const REQUEST_REFUND_PDF_SUCCESS = 'REQUEST_REFUND_PDF_SUCCESS';
export const REQUEST_RETURN_VOID = 'REQUEST_RETURN_VOID';
export const REQUEST_RETURN_COMPLETE = 'REQUEST_RETURN_COMPLETE';
export const FETCH_RETURN_SUCCESS = 'FETCH_RETURN_SUCCESS';
export const FETCH_RETURN_FAILURE = 'FETCH_RETURN_FAILURE';
export const REQUEST_PRODUCT_BY_ID = 'REQUEST_PRODUCT_BY_ID';
export const FETCH_PRODUCT_BY_ID_SUCCESS = 'FETCH_PRODUCT_BY_ID_SUCCESS';
export const FETCH_PRODUCT_BY_ID_FAILURE = 'FETCH_PRODUCT_BY_ID_FAILURE';
export const FETCH_PRODUCT_BY_ID = 'FETCH_PRODUCT_BY_ID';
export const FETCH_SALES_ORDER_SUGGESTIONS_SUCCESS = 'FETCH_SALES_ORDER_SUGGESTIONS_SUCCESS';
export const FETCH_SALES_ORDER_SUGGESTIONS_FAILURE = 'FETCH_SALES_ORDER_SUGGESTIONS_FAILURE';
export const FETCH_SALES_ORDER_SUGGESTIONS = 'FETCH_SALES_ORDER_SUGGESTIONS';
export const FETCH_PURCHASE_ORDER_SUGGESTIONS = 'FETCH_PURCHASE_ORDER_SUGGESTIONS';
export const FETCH_PURCHASE_ORDER_SUGGESTIONS_SUCCESS = 'FETCH_PURCHASE_ORDER_SUGGESTIONS_SUCCESS';
export const FETCH_PURCHASE_ORDER_SUGGESTIONS_FAILURE = 'FETCH_PURCHASE_ORDER_SUGGESTIONS_FAILURE';
export const FETCH_PRODUCT_SUGGESTIONS = 'FETCH_PRODUCT_SUGGESTIONS';
export const FETCH_PRODUCT_SUGGESTIONS_SUCCESS = 'FETCH_PRODUCT_SUGGESTIONS_SUCCESS';
export const FETCH_PRODUCT_SUGGESTIONS_FAILURE = 'FETCH_PRODUCT_SUGGESTIONS_FAILURE';
export const REQUEST_SALES_TOTALS = 'REQUEST_SALES_TOTALS';
export const FETCH_SALES_TOTALS_SUCCESS = 'FETCH_SALES_TOTALS_SUCCESS';
export const FETCH_SALES_TOTALS_FAILURE = 'FETCH_SALES_TOTALS_FAILURE';
export const CREATE_MOBILE_TASK = 'CREATE_MOBILE_TASK_SUCCESS';
export const CREATE_MOBILE_TASK_SUCCESS = 'CREATE_MOBILE_TASK_SUCCESS';
export const CREATE_MOBILE_TASK_FAILURE = 'CREATE_MOBILE_TASK_SUCCESS';
export const FETCH_STORES_SUCCESS = 'FETCH_STORES_SUCCESS';
export const FETCHING_STORES = 'FETCHING_STORES';

export const KEEP_EST_DATE = 'KEEP_EST_DATE';
export const FINISHED_UNMOUNT = 'FINISHED_UNMOUNT';
export const DESTROY_EST_DATE = 'DESTROY_EST_DATE';

// Favorite List action types
export const REQUEST_CUSTOMER_FAVORITES = 'REQUEST_CUSTOMER_FAVORITES';
export const FETCH_CUSTOMER_FAVORITES_SUCCESS = 'FETCH_CUSTOMER_FAVORITES_SUCCESS';
export const FETCH_CUSTOMER_FAVORITES_FAILURE = 'FETCH_CUSTOMER_FAVORITES_FAILURE';
export const SELECT_CUSTOMER_FAVORITES = 'SELECT_CUSTOMER_FAVORITES';
export const RESET_CURRENT_CUSTOMER_FAVORITES = 'RESET_CURRENT_CUSTOMER_FAVORITES';
export const REQUEST_CUSTOMER_FAVORITES_DETAIL = 'REQUEST_CUSTOMER_FAVORITES_DETAIL';
export const FETCH_CUSTOMER_FAVORITES_DETAIL_SUCCESS = 'FETCH_CUSTOMER_FAVORITES_DETAIL_SUCCESS';
export const FETCH_CUSTOMER_FAVORITES_DETAIL_FAILURE = 'FETCH_CUSTOMER_FAVORITES_DETAIL_FAILURE';
export const REQUEST_ADDING_CUSTOMER_FAVORITE = 'REQUEST_ADDING_CUSTOMER_FAVORITE';
export const ADD_CUSTOMER_FAVORITE_SUCCESS = 'ADD_CUSTOMER_FAVORITE_SUCCESS';
export const ADD_CUSTOMER_FAVORITE_FAILURE = 'ADD_CUSTOMER_FAVORITE_FAILURE';
export const REQUEST_DELETE_CUSTOMER_FAVORITE = 'REQUEST_DELETE_CUSTOMER_FAVORITE';
export const DELETE_CUSTOMER_FAVORITE_SUCCESS = 'DELETE_CUSTOMER_FAVORITE_SUCCESS';
export const DELETE_CUSTOMER_FAVORITE_FAILURE = 'DELETE_CUSTOMER_FAVORITE_FAILURE';
export const FETCH_CUSTOMERS_WITH_FAVORITES = 'FETCH_CUSTOMERS_WITH_FAVORITES';
export const REQUEST_CUSTOMERS_WITH_FAVORITES = 'REQUEST_CUSTOMERS_WITH_FAVORITES';
export const FETCH_CUSTOMERS_WITH_FAVORITES_SUCCESS = 'FETCH_CUSTOMERS_WITH_FAVORITES_SUCCESS';
export const FETCH_CUSTOMERS_WITH_FAVORITES_FAILURE = 'FETCH_CUSTOMERS_WITH_FAVORITES_FAILURE';
export const REQUEST_ADDING_NEW_FAVORITE_LIST = 'REQUEST_ADDING_NEW_FAVORITE_LIST';
export const ADD_NEW_FAVORITE_LIST_SUCCESS = 'ADD_NEW_FAVORITE_LIST_SUCCESS';
export const ADD_NEW_FAVORITE_LIST_FAILURE = 'ADD_NEW_FAVORITE_LIST_FAILURE';

// Group List action types
export const REQUEST_CUSTOMER_GROUPS = 'REQUEST_CUSTOMER_GROUPS';
export const FETCH_CUSTOMER_GROUPS_SUCCESS = 'FETCH_CUSTOMER_GROUPS_SUCCESS';
export const FETCH_CUSTOMER_GROUPS_FAILURE = 'FETCH_CUSTOMER_GROUPS_FAILURE';
export const REQUEST_CUSTOMER_GROUPS_DETAIL = 'REQUEST_CUSTOMER_GROUPS_DETAIL';
export const FETCH_CUSTOMER_GROUPS_DETAIL_SUCCESS = 'FETCH_CUSTOMER_GROUPS_DETAIL_SUCCESS';
export const FETCH_CUSTOMER_GROUPS_DETAIL_FAILURE = 'FETCH_CUSTOMER_GROUPS_DETAIL_FAILURE';
export const REQUEST_SAVE_PRODUCT_LIST = 'REQUEST_SAVE_PRODUCT_LIST';
export const SAVE_PRODUCT_LIST_SUCCESS = 'SAVE_PRODUCT_LIST_SUCCESS';
export const SAVE_PRODUCT_LIST_FAILURE = 'SAVE_PRODUCT_LIST_FAILURE';

// Sales Invoice action types
export const REQUEST_SALES_INVOICES = 'REQUEST_SALES_INVOICES';
export const REQUEST_SALES_INVOICES_BY_NUM = 'REQUEST_SALES_INVOICES_BY_NUM';
export const FETCH_SALES_INVOICES_BY_NUM_SUCCESS = 'FETCH_SALES_INVOICES_BY_NUM_SUCCESS';
export const FETCH_SALES_INVOICES_BY_NUM_FAILURE = 'FETCH_SALES_INVOICES_BY_NUM_FAILURE';
export const FETCH_SALES_INVOICES_SUCCESS = 'FETCH_SALES_INVOICES_SUCCESS';
export const FETCH_SALES_INVOICES_FAILURE = 'FETCH_SALES_INVOICES_FAILURE';
export const SELECT_SALES_INVOICE = 'SELECT_SALES_INVOICE';
export const RESET_CURRENT_SALES_INVOICE = 'RESET_CURRENT_SALES_INVOICE';
export const REQUEST_SALES_INVOICE_DETAIL = 'REQUEST_SALES_INVOICE_DETAIL';
export const FETCH_SALES_INVOICE_DETAIL_SUCCESS = 'FETCH_SALES_INVOICE_DETAIL_SUCCESS';
export const FETCH_SALES_INVOICE_DETAIL_FAILURE = 'FETCH_SALES_INVOICE_DETAIL_FAILURE';
export const REQUEST_FINALIZE_INVOICE = 'REQUEST_FINALIZE_INVOICE';
export const FINALIZE_INVOICE_SUCCESS = 'FINALIZE_INVOICE_SUCCESS';
export const FINALIZE_INVOICE_FAILURE = 'FINALIZE_INVOICE_FAILURE';
export const DELIVER_INVOICE_SUCCESS = 'REQUEST_DELIVER_INVOICE';
export const DELIVER_INVOICE_FAILURE = 'DELIVER_INVOICE_SUCCESS';
export const REQUEST_DELIVER_INVOICE = 'DELIVER_INVOICE_FAILURE';
export const REQUEST_VOID_INVOICE = 'REQUEST_VOID_INVOICE';
export const VOID_INVOICE_SUCCESS = 'VOID_INVOICE_SUCCESS';
export const VOID_INVOICE_FAILURE = 'VOID_INVOICE_FAILURE';
export const REQUEST_VOID_RETURN = 'REQUEST_VOID_RETURN';
export const VOID_RETURN_SUCCESS = 'VOID_RETURN_SUCCESS';
export const VOID_RETURN_FAILURE = 'VOID_RETURN_FAILURE';
export const REQUEST_FINALIZED_INVOICES = 'REQUEST_FINALIZED_INVOICES';
export const FETCH_FINALIZED_INVOICES_SUCCESS = 'FETCH_FINALIZED_INVOICES_SUCCESS';
export const FETCH_FINALIZED_INVOICES_FAILURE = 'FETCH_FINALIZED_INVOICES_FAILURE';
export const UPDATE_SALES_INVOICE = 'UPDATE_SALES_INVOICE';
export const UPDATE_SALES_INVOICE_SUCCESS = 'UPDATE_SALES_INVOICE_SUCCESS';
export const UPDATE_SALES_INVOICE_FAILURE = 'UPDATE_SALES_INVOICE_FAILURE';
export const UPDATE_SALES_INVOICE_PAYMENT = 'UPDATE_SALES_INVOICE_PAYMENT';
export const UPDATE_SALES_INVOICE_PAYMENT_SUCCESS = 'UPDATE_SALES_INVOICE_PAYMENT_SUCCESS';
export const UPDATE_SALES_INVOICE_PAYMENT_FAILURE = 'UPDATE_SALES_INVOICE_PAYMENT_FAILURE';
export const RESET_SALES_INVOICE_PAYMENT = 'RESET_SALES_INVOICE_PAYMENT';
export const CLEAR_UPDATE_SALES_INVOICE = 'CLEAR_UPDATE_SALES_INVOICE';
export const UPDATE_SALES_INVOICE_RESET = 'UPDATE_SALES_INVOICE_RESET';
export const REQUEST_SALES_INVOICE_FORM = 'REQUEST_SALES_INVOICE_FORM';
export const FETCH_SALES_INVOICE_FORM_SUCCESS = 'FETCH_SALES_INVOICE_FORM_SUCCESS';
export const FETCH_SALES_INVOICE_FORM_FAILURE = 'FETCH_SALES_INVOICE_FORM_FAILURE';
export const EDIT_SI_CUSTOMER = 'EDIT_SI_CUSTOMER';
export const EDIT_SI_CUSTOMER_SUCCESS = 'EDIT_SI_CUSTOMER_SUCCESS';
export const EDIT_SI_CUSTOMER_FAILURE = 'EDIT_SI_CUSTOMER_FAILURE';
export const RESET_EDIT_SI_CUSTOMER = 'RESET_EDIT_SI_CUSTOMER';
export const REQUEST_UNPAID_INVOICE = 'REQUEST_UNPAID_INVOICE';
export const FETCH_UNPAID_INVOICE_SUCCESS = 'FETCH_UNPAID_INVOICE_SUCCESS';
export const FETCH_UNPAID_INVOICE_FAILURE = 'FETCH_UNPAID_INVOICE_FAILURE';

export const COMPLETE_PURCHASE_ORDER = 'COMPLETE_PURCHASE_ORDER';
export const COMPLETE_PURCHASE_ORDER_SUCCESS = 'COMPLETE_PURCHASE_ORDER_SUCCESS';
export const COMPLETE_PURCHASE_ORDER_FAILURE = 'COMPLETE_PURCHASE_ORDER_FAILURE';
export const COPY_PURCHASE_ORDER = 'COPY_PURCHASE_ORDER';
export const COPY_PURCHASE_ORDER_SUCCESS = 'COPY_PURCHASE_ORDER_SUCCESS';
export const COPY_PURCHASE_ORDER_FAILURE = 'COPY_PURCHASE_ORDER_FAILURE';

// Wholesale action types
export const REQUEST_INVENTORY_BATCHES = 'REQUEST_INVENTORY_BATCHES';
export const FETCH_INVENTORY_BATCHES_SUCCESS = 'FETCH_INVENTORY_BATCHES_SUCCESS';
export const FETCH_INVENTORY_BATCHES_FAILURE = 'FETCH_INVENTORY_BATCHES_FAILURE';
export const REQUEST_PRODUCT_INVENTORY_BATCHES = 'REQUEST_PRODUCT_INVENTORY_BATCHES';
export const FETCH_PRODUCT_INVENTORY_BATCHES_SUCCESS = 'FETCH_PRODUCT_INVENTORY_BATCHES_SUCCESS';
export const FETCH_PRODUCT_INVENTORY_BATCHES_FAILURE = 'FETCH_PRODUCT_INVENTORY_BATCHES_FAILURE';

// Dispatch action types
export const SAVE_EDITED_STOPS = 'SAVE_EDITED_STOPS';
export const SAVE_EDITED_STOPS_SUCCESS = 'SAVE_EDITED_STOPS_SUCCESS';
export const SAVE_EDITED_STOPS_FAILURE = 'SAVE_EDITED_STOPS_FAILURE';
export const REQUEST_SAVE_NEW_ROUTES = 'REQUEST_SAVE_NEW_ROUTES';
export const SAVE_NEW_ROUTES_SUCCESS = 'SAVE_NEW_ROUTES_SUCCESS';
export const SAVE_NEW_ROUTES_FAILURE = 'SAVE_NEW_ROUTES_FAILURE';
export const REQUEST_ROUTES = 'REQUEST_ROUTES';
export const FETCH_ROUTES_SUCCESS = 'FETCH_ROUTES_SUCCESS';
export const FETCH_AUTO_ROUTES_SUCCESS = 'FETCH_AUTO_ROUTES_SUCCESS';
export const REQUEST_ALL_ROUTES = 'REQUEST_ALL_ROUTES';
export const FETCH_ALL_ROUTES_SUCCESS = 'FETCH_ALL_ROUTES_SUCCESS';
export const FETCH_ALL_ROUTES_FAILURE = 'FETCH_ALL_ROUTES_FAILURE';
export const START_FETCHING_AUTO_ROUTES = 'START_FETCHING_AUTO_ROUTES';
export const FETCH_ROUTES_FAILURE = 'FETCH_ROUTES_FAILURE';
export const REQUEST_STOPS = 'REQUEST_STOPS';
export const FETCH_STOPS_SUCCESS = 'FETCH_STOPS_SUCCESS';
export const FETCH_STOPS_FAILURE = 'FETCH_STOPS_FAILURE';
export const REQUEST_EDIT_STOPS = 'REQUEST_EDIT_STOPS';
export const FETCH_EDIT_STOPS_SUCCESS = 'FETCH_EDIT_STOPS_SUCCESS';
export const FETCH_EDIT_STOPS_FAILURE = 'FETCH_EDIT_STOPS_FAILURE';
export const REQUEST_SAVE_EDITS = 'REQUEST_SAVE_EDITS';
export const SAVE_EDITS_SUCCESS = 'SAVE_EDITS_SUCCESS';
export const SAVE_EDITS_FAILURE = 'SAVE_EDITS_FAILURE';
export const CLEAR_EDIT_STATUS = 'CLEAR_EDIT_STATUS';
export const REQUEST_CUSTOMER_ROUTES = 'REQUEST_CUSTOMER_ROUTES';
export const FETCH_CUSTOMER_ROUTES_SUCCESS = 'FETCH_CUSTOMER_ROUTES_SUCCESS';
export const FETCH_CUSTOMER_ROUTES_FAILURE = 'FETCH_CUSTOMER_ROUTES_FAILURE';
export const REQUEST_UNASSIGNED_ORDERS = 'REQUEST_UNASSIGNED_ORDERS';
export const FETCH_UNASSIGNED_ORDERS_SUCCESS = 'FETCH_UNASSIGNED_ORDERS_SUCCESS';
export const FETCH_UNASSIGNED_ORDERS_FAILURE = 'FETCH_UNASSIGNED_ORDERS_FAILURE';
export const REQUEST_SALES_ORDERS_BY_DATE = 'REQUEST_SALES_ORDERS_BY_DATE';
export const FETCH_SALES_ORDERS_BY_DATE_SUCCESS = 'FETCH_SALES_ORDERS_BY_DATE_SUCCESS';
export const FETCH_SALES_ORDERS_BY_DATE_FAILURE = 'FETCH_SALES_ORDERS_BY_DATE_FAILURE';
export const REQUEST_ASSIGN_ORDER_ROUTE = 'REQUEST_ASSIGN_ORDER_ROUTE';
export const ASSIGN_ORDER_ROUTE_SUCCESS = 'ASSIGN_ORDER_ROUTE_SUCCESS';
export const ASSIGN_ORDER_ROUTE_FAILURE = 'ASSIGN_ORDER_ROUTE_FAILURE';
export const REQUEST_SAVE_ROUTE_EDITS = 'REQUEST_SAVE_ROUTE_EDITS';
export const SAVE_ROUTE_EDIT_SUCCESS = 'SAVE_ROUTE_EDIT_SUCCESS';
export const SAVE_ROUTE_EDIT_FAILURE = 'SAVE_ROUTE_EDIT_FAILURE';
export const REQUEST_CONVERT_TO_INVOICE = 'REQUEST_CONVERT_TO_INVOICE';
export const CONVERT_TO_INVOICE_SUCCESS = 'CONVERT_TO_INVOICE_SUCCESS';
export const CONVERT_TO_INVOICE_FAILURE = 'CONVERT_TO_INVOICE_FAILURE';
export const CLEAR_CONVERT_TO_INVOICE = 'CLEAR_CONVERT_TO_INVOICE';
export const CONVERT_TO_INVOICE_RESET = 'CONVERT_TO_INVOICE_RESET';

// Dispatch driver action types
export const SELECT_DRIVER = 'SELECT_DRIVER';
export const RESET_CURRENT_DRIVER = 'RESET_CURRENT_DRIVER';
export const CREATE_DRIVER_SUCCESS = 'CREATE_DRIVER_SUCCESS';
export const CREATE_DRIVER_FAILURE = 'CREATE_DRIVER_FAILURE';
export const EDIT_DRIVER_SUCCESS = 'EDIT_DRIVER_SUCCESS';
export const EDIT_DRIVER_FAILURE = 'EDIT_DRIVER_FAILURE';
export const RESET_CREATE_DRIVER = 'RESET_CREATE_DRIVER';
export const RESET_EDIT_DRIVER = 'RESET_EDIT_DRIVER';

export const REQUEST_AR = 'REQUEST_AR';
export const FETCH_AR_SUCCESS = 'FETCH_AR_SUCCESS';
export const FETCH_AR_FAILURE = 'FETCH_AR_FAILURE';
export const CREATE_AR = 'CREATE_AR';
export const CREATE_AR_SUCCESS = 'CREATE_AR_SUCCESS';
export const CREATE_AR_FAILURE = 'CREATE_AR_FAILURE';
export const REFUND_AR = 'REFUND_AR';
export const REFUND_AR_SUCCESS = 'REFUND_AR_SUCCESS';
export const REFUND_AR_FAILURE = 'REFUND_AR_FAILURE';
export const EDIT_AR = 'EDIT_AR';
export const EDIT_AR_SUCCESS = 'EDIT_AR_SUCCESS';
export const EDIT_AR_FAILURE = 'EDIT_AR_FAILURE';
export const DELETE_AR = 'DELETE_AR';
export const DELETE_AR_SUCCESS = 'DELETE_AR_SUCCESS';
export const DELETE_AR_FAILURE = 'DELETE_AR_FAILURE';
export const REQUEST_AR_DETAIL = 'REQUEST_AR_DETAIL';
export const FETCH_AR_DETAIL_SUCCESS = 'FETCH_AR_DETAIL_SUCCESS';
export const FETCH_AR_DETAIL_FAILURE = 'FETCH_AR_DETAIL_FAILURE';
export const CLEAR_AR_DETAIL = 'CLEAR_AR_DETAIL';
export const CLEAR_AR_FORM = 'CLEAR_AR_FORM';
export const REQUEST_INVOICES = 'REQUEST_INVOICES';
export const FETCH_INVOICES_SUCCESS = 'FETCH_INVOICES_SUCCESS';
export const FETCH_INVOICES_FAILURE = 'FETCH_INVOICES_FAILURE';
export const REQUEST_CREDITS = 'REQUEST_CREDITS';
export const FETCH_CREDITS_SUCCESS = 'FETCH_CREDITS_SUCCESS';
export const FETCH_CREDITS_FAILURE = 'FETCH_CREDITS_FAILURE';
export const CLEAR_CREDITS = 'CLEAR_CREDITS';
export const REQUEST_AR_ACCOUNTS = 'REQUEST_AR_ACCOUNTS';
export const FETCH_AR_ACCOUNTS_SUCCESS = 'FETCH_AR_ACCOUNTS_SUCCESS';
export const FETCH_AR_ACCOUNTS_FAILURE = 'FETCH_AR_ACCOUNTS_FAILURE';
export const CLEAR_AR_ACCOUNTS = 'CLEAR_AR_ACCOUNTS';
export const BOUNCE_CHECK = 'BOUNCE_CHECK';
export const BOUNCE_CHECK_SUCCESS = 'BOUNCE_CHECK_SUCCESS';
export const BOUNCE_CHECK_FAILURE = 'BOUNCE_CHECK_FAILURE';

export const REQUEST_AP = 'REQUEST_AP';
export const FETCH_AP_SUCCESS = 'FETCH_AP_SUCCESS';
export const FETCH_AP_FAILURE = 'FETCH_AP_FAILURE';
export const CREATE_AP = 'CREATE_AP';
export const CREATE_AP_SUCCESS = 'CREATE_AP_SUCCESS';
export const CREATE_AP_FAILURE = 'CREATE_AP_FAILURE';
export const EDIT_AP = 'EDIT_AP';
export const EDIT_AP_SUCCESS = 'EDIT_AP_SUCCESS';
export const EDIT_AP_FAILURE = 'EDIT_AP_FAILURE';
export const DELETE_AP = 'DELETE_AP';
export const DELETE_AP_SUCCESS = 'DELETE_AP_SUCCESS';
export const DELETE_AP_FAILURE = 'DELETE_AP_FAILURE';
export const REQUEST_AP_DETAIL = 'REQUEST_AP_DETAIL';
export const FETCH_AP_DETAIL_SUCCESS = 'FETCH_AP_DETAIL_SUCCESS';
export const FETCH_AP_DETAIL_FAILURE = 'FETCH_AP_DETAIL_FAILURE';
export const CLEAR_AP_DETAIL = 'CLEAR_AP_DETAIL';
export const CLEAR_AP_FORM = 'CLEAR_AP_FORM';

export const REQUEST_STATEMENT = 'REQUEST_STATEMENT';
export const FETCH_STATEMENT_SUCCESS = 'FETCH_STATEMENT_SUCCESS';
export const FETCH_STATEMENT_FAILURE = 'FETCH_STATEMENT_FAILURE';
export const REQUEST_STATEMENT_AP = 'REQUEST_STATEMENT_AP';
export const FETCH_STATEMENT_AP_SUCCESS = 'FETCH_STATEMENT_AP_SUCCESS';
export const FETCH_STATEMENT_AP_FAILURE = 'FETCH_STATEMENT_AP_FAILURE';
export const RESET_CURRENT_CHECK = 'RESET_CURRENT_CHECK';
export const SELECT_CHECK = 'SELECT_CHECK';

export const REQUEST_BASE_USER = 'REQUEST_BASE_USER';
export const FETCH_BASE_USER_SUCCESS = 'FETCH_BASE_USER_SUCCESS';
export const FETCH_BASE_USER_FAILURE = 'FETCH_BASE_USER_FAILURE';
export const REQUEST_BASE_USER_DETAIL = 'REQUEST_BASE_USER_DETAIL';
export const FETCH_BASE_USER_DETAIL_SUCCESS = 'FETCH_BASE_USER_DETAIL_SUCCESS';
export const FETCH_BASE_USER_DETAIL_FAILURE = 'FETCH_BASE_USER_DETAIL_FAILURE';
export const REQUEST_MOBILE_USERS = 'REQUEST_MOBILE_USERS';
export const FETCH_MOBILE_USERS_SUCCESS = 'FETCH_MOBILE_USERS_SUCCESS';
export const FETCH_MOBILE_USERS_FAILURE = 'FETCH_MOBILE_USERS_FAILURE';
export const SELECT_CURRENT_USER = 'SELECT_CURRENT_USER';
export const RESET_CURRENT_USER = 'RESET_CURRENT_USER';
export const REQUEST_USER_GROUPS = 'REQUEST_USER_GROUPS';
export const FETCH_USER_GROUPS_SUCCESS = 'FETCH_USER_GROUPS_SUCCESS';
export const FETCH_USER_GROUPS_FAILURE = 'FETCH_USER_GROUPS_FAILURE';
export const SELECT_CURRENT_GROUP = 'SELECT_CURRENT_GROUP';
export const RESET_CURRENT_USER_GROUP = 'RESET_CURRENT_USER_GROUP';
export const REQUEST_PERMISSIONS = 'REQUEST_PERMISSIONS';
export const FETCH_PERMISSION_SUCCESS = 'FETCH_PERMISSION_SUCCESS';
export const FETCH_PERMISSION_FAILURE = 'FETCH_PERMISSION_FAILURE';
export const EDIT_GROUP_DETAIL = 'EDIT_GROUP_DETAIL';
export const EDIT_GROUP_DETAIL_SUCCESS = 'EDIT_GROUP_DETAIL_SUCCESS';
export const EDIT_GROUP_DETAIL_FAILURE = 'EDIT_GROUP_DETAIL_FAILURE';
export const FETCH_PERMISSIONS_SUCCESS = 'FETCH_PERMISSIONS_SUCCESS';
export const FETCH_PERMISSIONS_FAILURE = 'FETCH_PERMISSIONS_FAILURE';
export const EDIT_USER_DETAIL = 'EDIT_USER_DETAIL';
export const EDIT_USER_DETAIL_SUCCESS = 'EDIT_USER_DETAIL_SUCCESS';
export const EDIT_USER_DETAIL_FAILURE = 'EDIT_USER_DETAIL_FAILURE';
export const RESET_USER_DETAIL = 'RESET_USER_DETAIL';
export const CREATE_USER_DETAIL = 'CREATE_USER_DETAIL';
export const CREATE_USER_DETAIL_SUCCESS = 'CREATE_USER_DETAIL_SUCCESS';
export const CREATE_USER_DETAIL_FAILURE = 'CREATE_USER_DETAIL_FAILURE';
export const CREATE_GROUP_DETAIL = 'CREATE_GROUP_DETAIL';
export const CREATE_GROUP_DETAIL_SUCCESS = 'CREATE_GROUP_DETAIL_SUCCESS';
export const CREATE_GROUP_DETAIL_FAILURE = 'CREATE_GROUP_DETAIL_FAILURE';
export const EDIT_PASSWORD = 'EDIT_PASSWORD';
export const EDIT_PASSWORD_SUCCESS = 'EDIT_PASSWORD_SUCCESS';
export const EDIT_PASSWORD_FAILURE = 'EDIT_PASSWORD_FAILURE';
export const RESET_PASSWORD = 'RESET_PASSWORD';

export const REQUEST_PACKER = 'REQUEST_PACKER';
export const FETCH_PACKER_SUCCESS = 'FETCH_PACKER_SUCCESS';
export const FETCH_PACKER_FAILURE = 'FETCH_PACKER_FAILURE';

export const SELECT_PACKER = 'SELECT_PACKER';
export const RESET_CURRENT_PACKER = 'RESET_CURRENT_PACKER';

export const CREATE_PACKER_SUCCESS = 'CREATE_PACKER_SUCCESS';
export const CREATE_PACKER_FAILURE = 'CREATE_PACKER_FAILURE';
export const RESET_CREATE_PACKER = 'RESET_CREATE_PACKER';

export const EDIT_PACKER_SUCCESS = 'EDIT_PACKER_SUCCESS';
export const EDIT_PACKER_FAILURE = 'EDIT_PACKER_FAILURE';
export const RESET_EDIT_PACKER = 'RESET_EDIT_PACKER';

export const ATTACH_FILES = 'ATTACH_FILES';
export const ATTACH_FILES_SUCCESS = 'ATTACH_FILES_SUCCESS';
export const ATTACH_FILES_FAILURE = 'ATTACH_FILES_FAILURE';
export const FETCH_ATTACHED_FILES = 'FETCH_ATTACHED_FILES';
export const FETCH_ATTACHED_FILES_SUCCESS = 'FETCH_ATTACHED_FILES_SUCCESS';
export const FETCH_ATTACHED_FILES_FAILURE = 'FETCH_ATTACHED_FILES_FAILURE';
export const DELETE_ATTACHED_FILES = 'DELETE_ATTACHED_FILES';
export const DELETE_ATTACHED_FILES_SUCCESS = 'DELETE_ATTACHED_FILES_SUCCESS';
export const DELETE_ATTACHED_FILES_FAILURE = 'DELETE_ATTACHED_FILES_FAILURE';
export const RESET_ATTACHED_FILES = 'RESET_ATTACHED_FILES';

export const ATTACH_DOCUMENT = 'ATTACH_DOCUMENT';
export const ATTACH_DOCUMENT_SUCCESS = 'ATTACH_DOCUMENT_SUCCESS';
export const ATTACH_DOCUMENT_FAILURE = 'ATTACH_DOCUMENT_FAILURE';

// Dashboard actions
export const REQUEST_DASHBOARD_MESSAGES = 'REQUEST_DASHBOARD_MESSAGES';
export const FETCH_DASHBOARD_MESSAGES_SUCCESS = 'FETCH_DASHBOARD_MESSAGES_SUCCESS';
export const FETCH_DASHBOARD_MESSAGES_FAILURE = 'FETCH_DASHBOARD_MESSAGES_FAILURE';
export const POST_DASHBOARD_MESSAGE = 'POST_DASHBOARD_MESSAGE';
export const POST_MESSAGE_SUCCESS = 'POST_MESSAGE_SUCCESS';
export const POST_MESSAGE_FAILURE = 'POST_MESSAGE_FAILURE';
export const REQUEST_CONSOLIDATED_STATISTICS = 'REQUEST_CONSOLIDATED_STATISTICS';
export const FETCH_CONSOLODATED_STATISTICS_SUCCESS = 'FETCH_CONSOLODATED_STATISTICS_SUCCESS';
export const FETCH_CONSOLODATED_STATISTICS_FAILURE = 'FETCH_CONSOLODATED_STATISTICS_FAILURE';

// Register actions
export const REQUEST_REGISTERS = 'REQUEST_REGISTERS';
export const FETCH_REGISTERS_SUCCESS = 'FETCH_REGISTERS_SUCCESS';
export const FETCH_REGISTERS_FAILRE = 'FETCH_REGISTERS_FAILRE';
export const REQUEST_REGISTER_SESSIONS = 'REQUEST_REGISTER_SESSIONS';
export const REQUEST_REGISTER_SESSIONS_DATE = 'REQUEST_REGISTER_SESSIONS_DATE';
export const FETCH_REGISTER_SESSIONS_SUCCESS = 'FETCH_REGISTER_SESSIONS_SUCCESS';
export const FETCH_REGISTER_SESSIONS_FAILURE = 'FETCH_REGISTER_SESSIONS_FAILURE';
export const VERIFY_REGISTER = 'VERIFY_REGISTER';

// Print actions
export const REQUEST_SHIPPING_LIST_PDF = 'REQUEST_SHIPPING_LIST_PDF';
export const FETCH_SHIPPING_LIST_SUCCESS = 'FETCH_SHIPPING_LIST_SUCCESS';
export const REQUEST_PACKING_LIST_PDF = 'REQUEST_PACKING_LIST_PDF';
export const FETCH_PACKING_LIST_SUCCESS = 'FETCH_PACKING_LIST_SUCCESS';
export const REQUEST_SO_PDF = 'REQUEST_SO_PDF';
export const FETCH_SO_PDF_SUCCESS = 'FETCH_SO_PDF_SUCCESS';
export const REQUEST_SO_SI_PDF = 'REQUEST_SO_SI_PDF';
export const FETCH_SO_SI_PDF_SUCCESS = 'FETCH_SO_SI_PDF_SUCCESS';
export const REQUEST_PICKING_LIST_PDF = 'REQUEST_PICKING_LIST_PDF';
export const FETCH_PICKING_LIST_SUCCESS = 'FETCH_PICKING_LIST_SUCCESS';
export const REQUEST_PO_PDF = 'REQUEST_PO_PDF';
export const FETCH_PO_PDF_SUCCESS = 'FETCH_PO_PDF_SUCCESS';
export const REQUEST_PO_NOSUBTOTAL_PDF = `REQUEST_PO_NOSUBTOTAL_PDF`;
export const REQUEST_PO_NOSUBTOTAL_PDF_SUCCESS = `REQUEST_PO_NOSUBTOTAL_PDF_SUCCESS`;
export const REQUEST_SI_PDF = 'REQUEST_SI_PDF';
export const FETCH_SI_PDF_SUCCESS = 'FETCH_SI_PDF_SUCCESS';
export const FETCH_SI_PDF_FAILURE = 'FETCH_SI_PDF_FAILURE';
export const REQUEST_SI_RETURN_PDF = 'REQUEST_SI_RETURN_PDF';
export const FETCH_SI_RETURN_PDF_SUCCESS = 'FETCH_SI_RETURN_PDF_SUCCESS';
export const FETCH_SI_RETURN_PDF_FAILURE = 'FETCH_SI_RETURN_PDF_FAILURE';
export const REQUEST_WR_PDF = 'REQUEST_WR_PDF';
export const FETCH_WR_PDF_SUCCESS = 'FETCH_WR_PDF_SUCCESS';
export const REMOVE_SHIPPING_PDF = 'REMOVE_SHIPPING_PDF';
export const REQUEST_AR_PDF = 'REQUEST_AR_PDF';
export const FETCH_AR_PDF_SUCCESS = 'FETCH_AR_PDF_SUCCESS';
export const REQUEST_AP_PDF = 'REQUEST_AP_PDF';
export const FETCH_AP_PDF_SUCCESS = 'FETCH_AP_PDF_SUCCESS';
export const REQUEST_ROUTING_PDF_SUCCESS = 'REQUEST_ROUTING_PDF_SUCCESS';
export const REQUEST_ROUTING_PDF_FAILURE = 'REQUEST_ROUTING_PDF_FAILURE';
export const REQUEST_ROUTING_PDF = 'REQUEST_ROUTING_PDF';
export const REQUEST_DISPATCH_PICKING_LIST_PDF_SUCCESS = 'REQUEST_DISPATCH_PICKING_LIST_PDF_SUCCESS';
export const REQUEST_DISPATCH_PICKING_LIST_PDF_FAILURE = 'REQUEST_DISPATCH_PICKING_LIST_PDF_FAILURE';
export const REQUEST_DISPATCH_PICKING_LIST_PDF = 'REQUEST_DISPATCH_PICKING_LIST_PDF';
export const REQUEST_DISPATCH_PACKING_LIST_PDF_SUCCESS = 'REQUEST_DISPATCH_PACKING_LIST_PDF_SUCCESS';
export const REQUEST_DISPATCH_PACKING_LIST_PDF_FAILURE = 'REQUEST_DISPATCH_PACKING_LIST_PDF_FAILURE';
export const REQUEST_DISPATCH_PACKING_LIST_PDF = 'REQUEST_DISPATCH_PACKING_LIST_PDF';
export const REQUEST_DISPATCH_SALES_INVOICE_PDF_SUCCESS = 'REQUEST_DISPATCH_SALES_INVOICE_PDF_SUCCESS';
export const REQUEST_DISPATCH_SALES_INVOICE_PDF_FAILURE = 'REQUEST_DISPATCH_SALES_INVOICE_PDF_FAILURE';
export const REQUEST_DISPATCH_SALES_INVOICE_PDF = 'REQUEST_DISPATCH_SALES_INVOICE_PDF';
export const REQUEST_SI_NOSUBTOTAL_PDF = 'REQUEST_SI_NOSUBTOTAL_PDF';
export const REQUEST_SI_NOSUBTOTAL_PDF_SUCCESS = 'REQUEST_SI_NOSUBTOTAL_PDF_SUCCESS';
export const REQUEST_SI_RETURN_NOSUBTOTAL_PDF = 'REQUEST_SI_RETURN_NOSUBTOTAL_PDF';
export const REQUEST_SI_RETURN_NOSUBTOTAL_PDF_SUCCESS = 'REQUEST_SI_RETURN_NOSUBTOTAL_PDF_SUCCESS';
export const REQUEST_BOL_ID_PDF = 'REQUEST_BOL_ID_PDF';
export const FETCH_BOL_ID_PDF_SUCCESS = 'FETCH_BOL_ID_PDF_SUCCESS';
export const REQUEST_BOL_FBA_PDF = 'REQUEST_BOL_FBA_PDF';
export const FETCH_BOL_WITHOUT_LOG_SUCCESS = 'FETCH_BOL_WITHOUT_LOG_SUCCESS';
export const REQUEST_BOL_WITHOUT_LOG = 'REQUEST_BOL_WITHOUT_LOG';
export const REQUEST_BOL_LABEL = 'REQUEST_BOL_LABEL';
export const FETCH_BOL_LABEL_SUCCESS = 'FETCH_BOL_LABEL_SUCCESS';
export const FETCH_BOL_FBA_PDF_SUCCESS = 'FETCH_BOL_FBA_PDF_SUCCESS';
export const FETCH_BOL_ADDRESS_SUCCESS = 'FETCH_BOL_ADDRESS_SUCCESS';
export const FETCH_SP_SUCCESS = 'FETCH_SP_SUCCESS';
export const REQUEST_SP_PDF = 'REQUEST_SP_PDF';
export const REQUEST_COMMERCIAL_INVOICE_PDF = 'REQUEST_COMMERCIAL_INVOICE_PDF';
export const REQUEST_COMMERCIAL_INVOICE_PDF_SUCCESS = 'REQUEST_COMMERCIAL_INVOICE_PDF_SUCCESS';
export const REQUEST_COMMERCIAL_INVOICE_PDF_FAILURE = 'REQUEST_COMMERCIAL_INVOICE_PDF_FAILURE';


// Mobile Management actions
export const FETCH_GREAT_DEALS_NEW_ARRIVALS = 'FETCH_GREAT_DEALS_NEW_ARRIVALS';
export const FETCH_GREAT_DEALS_NEW_ARRIVALS_SUCCESS = 'FETCH_GREAT_DEALS_NEW_ARRIVALS_SUCCESS';
export const FETCH_GREAT_DEALS_NEW_ARRIVALS_FAILURE = 'FETCH_GREAT_DEALS_NEW_ARRIVALS_FAILURE';
export const UPDATE_GREAT_DEALS = 'UPDATE_GREAT_DEALS';
export const UPDATE_GREAT_DEALS_SUCCESS = 'UPDATE_GREAT_DEALS_SUCCESS';
export const UPDATE_GREAT_DEALS_FAILURE = 'UPDATE_GREAT_DEALS_FAILURE';
export const UPDATE_NEW_ARRIVALS = 'UPDATE_NEW_ARRIVALS';
export const UPDATE_NEW_ARRIVALS_SUCCESS = 'UPDATE_NEW_ARRIVALS_SUCCESS';
export const UPDATE_NEW_ARRIVALS_FAILURE = 'UPDATE_NEW_ARRIVALS_FAILURE';
export const GRAB_MOBILE_USER_ID = 'GRAB_MOBILE_USER_ID';
export const REQUEST_USERNAME = 'REQUEST_USERNAME';
export const REQUEST_USERNAME_SUCCESS = 'REQUEST_USERNAME_SUCCESS';
export const REQUEST_USERNAME_FAILURE = 'REQUEST_USERNAME_FAILURE';
export const CLEAR_USERNAME_DATA = 'CLEAR_USERNAME_DATA';
// Category Analysis auth_actions
export const CHOOSE_CATEGORY = 'CHOOSE_CATEGORY';

export const FETCH_BILLBOARD_IMAGES = 'FETCH_BILLBOARD_IMAGES';
export const FETCH_BILLBOARD_IMAGES_SUCCESS = 'FETCHING_BILLBOARD_IMAGES';
export const FETCH_BILLBOARD_IMAGES_FAILURE = 'FETCHING_BILLBOARD_IMAGES';
export const SAVE_BILLBOARD_IMAGES = 'SAVE_BILLBOARD_IMAGES';
export const SAVE_BILLBOARD_IMAGES_SUCCESS = 'SAVE_BILLBOARD_IMAGES_SUCCESS';
export const SAVE_BILLBOARD_IMAGES_FAILURE = 'SAVE_BILLBOARD_IMAGES_FAILURE';
export const DELETE_BILLBOARD_IMAGE = 'DELETE_BILLBOARD_IMAGE';
export const DELETE_BILLBOARD_IMAGE_SUCCESS = 'DELETE_BILLBOARD_IMAGE_SUCCESS';
export const DELETE_BILLBOARD_IMAGE_FAILURE = 'DELETE_BILLBOARD_IMAGE_FAILURE';

//RMA actions
export const REQUEST_CUSTOMER_SEARCH = 'REQUEST_CUSTOMER_SEARCH';
export const CUSTOMER_SEARCH_SUCCESS = 'CUSTOMER_SEARCH_SUCCESS';
export const RETURN_SEARCH_SUCCESS = "RETURN_SEARCH_SUCCESS";
export const CUSTOMER_SEARCH_FAILURE = 'CUSTOMER_SEARCH_FAILURE';
export const REQUEST_CUSTOMER_CREATE_RETURN = 'REQUEST_CUSTOMER_CREATE_RETURN';
export const CUSTOMER_CREATE_RETURN_SUCCESS = 'CUSTOMER_CREATE_RETURN_SUCCESS';
export const CUSTOMER_CREATE_RETURN_FAILURE = 'CUSTOMER_CREATE_RETURN_FAILURE';
export const REQUEST_CUSTOMER_EDIT_RETURN = 'REQUEST_CUSTOMER_EDIT_RETURN';
export const CUSTOMER_EDIT_RETURN_SUCCESS = 'CUSTOMER_EDIT_RETURN_SUCCESS';
export const CUSTOMER_EDIT_RETURN_FAILURE = 'CUSTOMER_EDIT_RETURN_FAILURE';
export const REQUEST_DISPATCH_EDIT_RETURN = 'REQUEST_DISPATCH_EDIT_RETURN';
export const DISPATCH_EDIT_RETURN_SUCCESS = 'DISPATCH_EDIT_RETURN_SUCCESS';
export const DISPATCH_EDIT_RETURN_FAILURE = 'DISPATCH_EDIT_RETURN_FAILURE';
export const REQUEST_DISPATCH_SEARCH = 'REQUEST_DISPATCH_SEARCH';
export const DISPATCH_SEARCH_SUCCESS = 'DISPATCH_SEARCH_SUCCESS';
export const DISPATCH_SEARCH_FAILURE = 'DISPATCH_SEARCH_FAILURE';
export const SET_RETURNS_FILTER = 'SET_RETURNS_FILTER';
export const RESET_CURRENT_RETURN = 'RESET_CURRENT_RETURN';
export const RESET_CURRENT_FORM = 'RESET_CURRENT_FORM';

// Adjustment Inventory page actions
export const REQUEST_REASONS = 'START_FETCHING_REASONS';
export const REQUEST_REASONS_SUCCESS = 'FETCH_REASONS_SUCCESS';
export const REQUEST_REASONS_FAILURE = 'FETCH_REASONS_FAILURE';
export const START_REASON_CREATION = 'START_REASON_CREATION';
export const REASON_CREATION_SUCCESS = 'REASON_CREATION_SUCCESS';
export const REASON_CREATION_FAILURE = 'REASON_CREATION_FAILURE';
export const START_REASON_EDITING = 'START_REASON_EDITING';
export const REASON_EDITING_SUCCESS = 'REASON_EDITING_SUCCESS';
export const REASON_EDITING_FAILURE = 'REASON_EDITING_FAILURE';
export const REQUEST_DELETE_REASON = 'REQUEST_DELETE_REASON';
export const REASON_DELETE_SUCCESS = 'REASON_DELETE_SUCCESS';
export const REASON_DELETE_FAILURE = 'REASON_DELETE_FAILURE';
export const SELECT_REASON = 'SELECT_REASON';
export const RESET_CURRENT_REASON = 'RESET_CURRENT_REASON';
export const REQUEST_ADJUSTMENT_LOGS = 'REQUEST_ADJUSTMENT_LOGS';
export const ADJUSTMENT_LOG_SUCCESS = 'ADJUSTMENT_LOG_SUCCESS';
export const ADJUSTMENT_LOG_FAILURE = 'ADJUSTMENT_LOG_FAILURE';

//settings actions
export const REQUEST_ACTION_LOG_BY_FILTER = 'REQUEST_ACTION_LOG_BY_FILTER';
export const ACTION_LOG_FILTER_SUCCESS = 'ACTION_LOG_FILTER_SUCESS';
export const ACTION_LOG_FILTER_FAILURE = 'ACTION_LOG_FILTER_FAILURE';
export const SET_SELECTED_BUSINESSUSER = 'SET_SELECTED_BUSINESSUSER';
export const WAREHOUSE_LIST = 'userManagement/WAREHOUSE_LIST';

//mmdriver action types
export const FETCH_MMDRIVER = 'FETCH_MMDRIVER';
export const FETCH_MMDRIVERS = 'FETCH_MMDRIVERS';

//Dispatch Action Types:
export const FETCH_ROUTES_PRINTER_SUCESS = "FETCH_ROUTES_PRINTER_SUCESS";
export const SAVE_ROUTES_PRINTER_SUCESS = "SAVE_ROUTES_PRINTER_SUCESS";
export const SET_AUTO_ROUTING_BUTTONS_LOADING = "SET_AUTO_ROUTING_BUTTONS_LOADING";

//BaseModal Action Types:
export const SET_CONFIRM_PASSCODE_MODAL_VISIBILITY = "SET_CONFIRM_PASSCODE_MODAL_VISIBILITY";
export const SET_PASSCODE_VERFICATION = "SET_PASSCODE_VERFICATION";

//Tracking Note Types:
export const FETCH_TRACKING_SUCCESS = "FETCH_TRACKING_SUCCESS";
export const EDIT_TRACKING_SUCCESS = "EDIT_TRACKING_SUCCESS";

//ESL:
export const REQUEST_INITIALIZE_ESL = "REQUEST_INITIALIZE_ESL";
export const REQUEST_DELETE_ESL = "REQUEST_DELETE_ESL";
export const REQUEST_FETCH_ESL_TEMPLATE = "REQUEST_FETCH_ESL_TEMPLATE";
export const REQUEST_SAVE_ESL = "REQUEST_SAVE_ESL";
export const REQUEST_FETCH_ESL = "REQUEST_FETCH_ESL";

// Merge Purchase Orders
export const MERGE_PURCHASE_ORDERS_LOADING = 'MERGE_PURCHASE_ORDERS_LOADING';
export const MERGE_PURCHASE_ORDERS_SUCCESS = 'MERGE_PURCHASE_ORDERS_SUCCESS';
export const MERGE_PURCHASE_ORDERS_ERROR = 'MERGE_PURCHASE_ORDERS_ERROR';
export const FETCH_SALES_QUOTES_SUCCESS = 'FETCH_SALES_QUOTES_SUCCESS';
export const REQUEST_SALES_QUOTE_BY_FILTER = 'REQUEST_SALES_QUOTE_BY_FILTER';
export const REQUEST_CREATING_SALES_QUOTE = 'REQUEST_CREATING_SALES_QUOTE';

export const REQUEST_SYNC_QB_PDF = 'REQUEST_SYNC_QB_PDF';
export const FETCH_SYNC_QB_PDF_SUCCESS = 'FETCH_SYNC_QB_PDF_SUCCESS';
export const FETCH_SYNC_QB_PDF_FAILURE = 'FETCH_SYNC_QB_PDF_FAILURE';

// market
export const SET_CURRENT_MARKETING = 'market/SET_CURRENT_MARKETING';
export const SET_MARKETING_ALL = 'market/SET_MARKETING_ALL';
export const RESET_MARKETING = 'market/RESET_MARKETING';
export const SET_MARKETING_PRODUCT_LIST = 'market/SET_MARKETING_PRODUCT_LIST';
export const FETCH_VENDOR_PRICE_TABLE = 'vendor/FETCH_VENDOR_PRICE_TABLE';
export const FETCH_VENDOR_PRICE_TABLE_SUCCESS = 'vendor/FETCH_VENDOR_PRICE_TABLE_SUCCESS';
export const FETCH_VENDOR_PRICE_TABLE_FAILURE = 'vendor/FETCH_VENDOR_PRICE_TABLE_FAILURE';
export const FETCH_VENDOR_PRODUCTS = 'vendor/FETCH_VENDOR_PRODUCTS';
export const FETCH_VENDOR_PRODUCTS_SUCCESS = 'vendor/FETCH_VENDOR_PRODUCTS_SUCCESS';
export const FETCH_VENDOR_PRODUCTS_FAILURE = 'vendor/FETCH_VENDOR_PRODUCTS_FAILURE';
export const UPDATE_VENDOR_PRICE_ITEM = 'vendor/UPDATE_VENDOR_PRICE_ITEM';
export const CREATE_VENDOR_PRICE_ITEM = 'vendor/CREATE_VENDOR_PRICE_ITEM';
export const DELETE_VENDOR_PRICE_ITEM = 'vendor/DELETE_VENDOR_PRICE_ITEM';
export const FETCH_VENDOR_PRICE_TABLE_DETAIL = 'vendor/FETCH_VENDOR_PRICE_TABLE_DETAIL';
export const FETCH_VENDOR_PRICE_TABLE_DETAIL_SUCCESS = 'vendor/FETCH_VENDOR_PRICE_TABLE_DETAIL_SUCCESS';
export const FETCH_VENDOR_PRICE_TABLE_DETAIL_FAILURE = 'vendor/FETCH_VENDOR_PRICE_TABLE_DETAIL_FAILURE';
export const UPDATE_VENDOR_PRICE_TABLE = 'vendor/UPDATE_VENDOR_PRICE_TABLE';
export const UPDATE_VENDOR_PRICE_TABLE_SUCCESS = 'vendor/UPDATE_VENDOR_PRICE_TABLE_SUCCESS';
export const UPDATE_VENDOR_PRICE_TABLE_FAILURE = 'vendor/UPDATE_VENDOR_PRICE_TABLE_FAILURE';

export const FETCH_CURRENT_ORDER_REQUESTS = 'salesOrderForm/FETCH_CURRENT_ORDER_REQUESTS';
export const ADD_PRODUCT_REQUESTS = 'salesOrderForm/ADD_PRODUCT_REQUESTS';
export const REMOVE_PRODUCT_REQUESTS = 'salesOrderForm/REMOVE_PRODUCT_REQUESTS';
export const ADD_PRODUCT_IMAGES = 'salesOrderForm/ADD_PRODUCT_IMAGES';
export const REMOVE_PRODUCT_IMAGES = 'salesOrderForm/REMOVE_PRODUCT_IMAGES';
export const ADD_PRODUCT_FILES = 'salesOrderForm/ADD_PRODUCT_FILES';
export const REMOVE_PRODUCT_FILES = 'salesOrderForm/REMOVE_PRODUCT_FILES';



// WEBPACK FOOTER //
// ./master/jsx/actions/type.js